// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
body {
  background-color: #111111 !important;
  color: #fff;
  font-family: "Orbitron", sans-serif !important;
  overflow-x: hidden;
  /* 🔥 horizontal scroll permanently band */
}

/* ===== GLOBAL SCROLLBAR ===== */
::-webkit-scrollbar-thumb {
  background: #4b3f5e;
  /* scrollbar color */
  border-radius: 10px;
}

::-webkit-scrollbar-thumb:hover {
  background: #4b3f5e;
}

/* Firefox */
* {
  scrollbar-width: thin;
  scrollbar-color: #4b3f5e #fff;
}

h1 {
  font-size: 2rem;
  color: #e50914;
  margin-bottom: 1rem;
}

.App {
  text-align: center;
}

.App-logo {
  height: 40vmin;
  pointer-events: none;
}

@media (prefers-reduced-motion: no-preference) {
  .App-logo {
    animation: App-logo-spin infinite 20s linear;
  }
}
.App-header {
  background-color: #282c34;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: calc(10px + 2vmin);
  color: white;
}

.App-link {
  color: #61dafb;
}

@keyframes App-logo-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.form-select {
  background-color: #333;
  color: #fff;
  border: none;
}

.card {
  background-color: #181818;
  border: none;
  transition: transform 0.3s ease;
}

.card:hover {
  transform: scale(1.03);
  z-index: 2;
}

.card-title,
.card-subtitle {
  color: #fff;
}

.card-link {
  color: #e50914;
  text-decoration: none;
}

.card-link:hover {
  text-decoration: underline;
}

.nav-tabs .nav-link {
  background-color: transparent;
  color: #999;
  border: none;
  border-bottom: 2px solid transparent;
}

.nav-tabs .nav-link.active {
  color: #fff;
  border-bottom: 2px solid #e50914;
}

.spinner-border {
  width: 3rem;
  height: 3rem;
}

.alert-info {
  background-color: #333;
  color: #fff;
  border-color: #e50914;
}

.video-row {
  --vip-row-gutter: 5px;
  --vip-row-arrow-gap: 0px;
  position: relative;
  padding: 0 var(--vip-row-gutter);
}

.vip-row-slider {
  --vip-row-gutter: 40px;
  --vip-row-arrow-gap: 6px;
  position: relative;
  padding: 0 var(--vip-row-gutter);
}

.video-card {
  min-width: 300px;
  max-width: 300px;
  flex: 0 0 auto;
}

/* Carousel navigation: exact 135° hollow chevrons with sharp geometry.
   The button remains a large full-height hit target; only the SVG is visible. */
.scroll-arrow {
  position: absolute;
  top: 50% !important;
  transform: translateY(-50%);
  z-index: 10;
  display: flex !important;
  align-items: center;
  justify-content: center;
  width: max(40px, var(--vip-row-gutter, 40px) - var(--vip-row-arrow-gap, 6px)) !important;
  height: 100% !important;
  min-height: 200px;
  padding: 0;
  border: none;
  color: rgba(255, 255, 255, 0.74) !important;
  font-size: 0 !important;
  line-height: 0 !important;
  cursor: pointer;
  outline: none;
  appearance: none;
  -webkit-tap-highlight-color: transparent;
}

.scroll-arrow::before,
.scroll-arrow::after {
  content: none !important;
  display: none !important;
}

.scroll-arrow.left {
  left: 0 !important;
  background: linear-gradient(to right, rgba(0, 0, 0, 0.32), rgba(0, 0, 0, 0)) !important;
}

.scroll-arrow.right {
  right: 0 !important;
  background: linear-gradient(to left, rgba(0, 0, 0, 0.32), rgba(0, 0, 0, 0)) !important;
}

.scroll-arrow__shape {
  display: block;
  width: auto;
  height: clamp(42px, 26%, 56px);
  overflow: visible;
  opacity: 1;
  filter: drop-shadow(0 2px 5px rgba(0, 0, 0, 0.5));
  transition: transform 0.16s ease, color 0.16s ease, opacity 0.16s ease;
  pointer-events: none;
}

.scroll-arrow:hover {
  color: #fff !important;
}

.scroll-arrow:hover .scroll-arrow__shape {
  transform: scale(1.035);
}

.scroll-arrow:focus-visible {
  outline: 2px solid rgba(167, 139, 250, 0.9);
  outline-offset: -2px;
}

.scroll-arrow.slick-disabled {
  cursor: default;
  color: rgba(255, 255, 255, 0.34) !important;
}

@media (max-width: 768px) {
  .video-row {
    --vip-row-gutter: 28px;
    --vip-row-arrow-gap: 4px;
    --mobile-scroll-arrow-edge-offset: 0px;
  }
  .vip-row-slider {
    --vip-row-gutter: 0px;
    --vip-row-arrow-gap: 0px;
    padding: 0;
  }
  .scroll-arrow {
    width: 48px !important;
    min-height: 120px;
    color: rgba(255, 255, 255, 0.8) !important;
  }
  .scroll-arrow.left {
    left: calc(var(--mobile-scroll-arrow-edge-offset, 0px) * -1) !important;
    background: linear-gradient(to right, rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0)) !important;
  }
  .scroll-arrow.right {
    right: calc(var(--mobile-scroll-arrow-edge-offset, 0px) * -1) !important;
    background: linear-gradient(to left, rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0)) !important;
  }
  .scroll-arrow__shape {
    height: clamp(34px, 32%, 46px);
  }
  .video-card {
    min-width: 240px;
    max-width: 240px;
  }
}
.scroll-container {
  overflow-x: auto;
  overflow-y: hidden;
}

/* Use native scrollbars; no WebKit overrides */
.video-card {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  /* pushes button to bottom */
  height: 100%;
  /* make all cards equal height */
  padding: 1rem;
  background-color: #1e1e2f;
  border-radius: 8px;
}

.video-info {
  flex: 1 1 auto;
  margin-bottom: 1rem;
  /* space before button */
}

.video-button {
  align-self: flex-start;
  /* or center if you prefer */
}

/* Remove custom override of overflow utility to preserve defaults */
/* Removed custom .fancy-scroll styles to restore native browser scrollbars */
.netflix-tabs .tab-content {
  padding-left: 0;
  padding-right: 0;
}

.trending-scroll {
  padding-right: 2rem;
  padding-left: 2rem;
}

.width_100 {
  width: 100% !important;
}

.country-select-box {
  margin-top: 2px !important;
}

/* NAVBAR  header */
/* LOGO — primary header brand, links to default home */
.ds-logo-link {
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  text-decoration: none;
  z-index: 2;
  cursor: pointer;
}
.ds-logo-link:hover, .ds-logo-link:focus-visible {
  opacity: 0.92;
}

.ds-logo-img {
  height: var(--ds-navbar-height, 70px);
  width: auto;
  object-fit: contain;
  display: block;
}

@media (min-width: 1001px) {
  .ds-logo-img {
    height: 99px;
    padding-top: 11px;
  }
}
/* LINKS */
.ds-link {
  color: rgba(255, 255, 255, 0.87);
  cursor: pointer;
  position: relative;
  padding: 6px 8px;
  transition: 0.2s;
  text-transform: uppercase;
}

.ds-link:hover {
  color: rgba(255, 255, 255, 0.9);
}

/* ACTIVE TAB */
.ds-active {
  color: rgba(255, 255, 255, 0.9);
}

.ds-menu-wrap {
  margin-top: 15px !important;
}

/* RESPONSIVE */
@media (max-width: 768px) {
  .ds-menu-wrap {
    gap: 8px !important;
  }
  .ds-country-select {
    max-width: 120px;
    font-size: 13px;
  }
}
/* Premium TV loader page styling */
.premium-loader-container {
  /* The initial headlines request owns the viewport; navigation is revealed
     with the loaded content so the header cannot flash ahead of the data. */
  position: relative;
  width: 100%;
  min-height: 100dvh;
  background: radial-gradient(circle at center, #181528 0%, #0a0a0f 100%);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  z-index: 2;
}

.premium-loader-img {
  width: min(340px, 80vw);
  height: auto;
  margin-bottom: 0;
}

.loading-text {
  font-family: "Orbitron", sans-serif;
  font-size: clamp(2.1rem, 3.5vw, 2.7rem);
  font-weight: 900;
  letter-spacing: 4px;
  color: #c084fc;
  margin-top: 35px;
  text-transform: uppercase;
  animation: loadingGlowPulse 2.6s ease-in-out infinite;
  text-align: center;
  line-height: 1.4;
}
@media (max-width: 768px) {
  .loading-text {
    font-size: clamp(1.4rem, 5vw, 2rem);
    letter-spacing: 2px;
  }
}

.loading-text-line {
  display: block;
  opacity: 0;
  transform: translateY(10px);
  animation: loadingLineReveal 0.42s ease-out forwards;
}

.loading-text-line--1 {
  animation-delay: 0.3s;
}

.loading-text-line--2 {
  animation-delay: 0.8s;
}

.loading-text-line--3 {
  animation-delay: 1.2s;
}

@keyframes loadingGlowPulse {
  0%, 100% {
    text-shadow: 0 0 4px rgba(197, 140, 255, 0.18), 0 0 10px rgba(197, 140, 255, 0.12);
  }
  50% {
    text-shadow: 0 0 8px rgba(197, 140, 255, 0.42), 0 0 20px rgba(197, 140, 255, 0.26), 0 0 34px rgba(197, 140, 255, 0.14);
  }
}
@keyframes loadingLineReveal {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@media (prefers-reduced-motion: reduce) {
  .loading-text {
    animation: none;
    text-shadow: 0 0 4px rgba(197, 140, 255, 0.18), 0 0 10px rgba(197, 140, 255, 0.12);
  }
}
/* Round spinning loader */
.spinner {
  width: 60px;
  height: 60px;
  border: 6px solid rgba(255, 255, 255, 0.2);
  border-top: 6px solid #ffffff;
  border-radius: 50%;
  animation: spin 0.9s linear infinite;
}

/* Animation */
@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
/* WRAPPER */
.vip-hero-play-btn:hover {
  background-color: #4b3f5e;
}

/* unique wrapper for each video */
.ytRowItemUnique {
  padding: 10px;
}

/* card look */
.ytRowItemUnique > div {
  border-radius: 16px;
  overflow: hidden;
  background: #121212;
  transition: transform 0.25s ease, box-shadow 0.25s ease;
}

.ytRowItemUnique > div:hover {
  transform: scale(1.03);
  box-shadow: 0 12px 28px rgba(0, 0, 0, 0.45);
}

/* remove center gap when few videos */
.slick-track {
  margin-left: 0 !important;
}

/* arrows styling */
.slick-prev,
.slick-next {
  z-index: 3;
}

.slick-prev:before,
.slick-next:before {
  content: none !important;
  display: none !important;
}

/* ===== MOBILE VIEW ===== */
@media (max-width: 548px) {
  .responsive_header {
    flex-direction: column;
  }
}
.vip-divider {
  position: relative;
  /* Keep the divider in the normal document flow (use absolute if parent is relative for overlay) */
  left: 0 !important;
  /* Force the divider to start from the very left edge */
  width: 100vw !important;
  /* Set width to full viewport width */
  height: 0.5px !important;
  /* Hair-thin line */
  background: #e6d7ff !important;
  /* Divider color */
  border-radius: 0 !important;
  /* Make the line straight */
  opacity: 0.9 !important;
  /* Slight transparency */
  margin-left: calc(-50vw + 50%) !important;
  margin-top: -17px;
  margin-bottom: 10px;
}

.news-block__title {
  display: block;
  width: 100%;
  box-sizing: border-box;
  margin: 0;
  color: #f4f4f6;
  font-family: "Space Grotesk", sans-serif;
  font-size: 15px !important;
  font-weight: 500;
  line-height: 1.2;
  padding-top: 0px;
  padding-bottom: 3px;
  padding-left: 5px;
}

@media (max-width: 768px) {
  .news-block__title {
    padding-left: 0px;
    padding-bottom: 0px;
  }
}
.vip-hero {
  --vip-full-bleed-overscan: 4px;
  position: static;
  width: calc(100vw + var(--vip-full-bleed-overscan));
  margin-left: calc(-50vw + 50% - var(--vip-full-bleed-overscan) / 2);
  height: 100vh;
  overflow: hidden;
  display: flex;
  align-items: center;
}

.vip-hero-player-inner {
  position: relative;
  width: 100%;
  padding-bottom: 56.25%;
  background: #000;
  border-radius: 12px;
  overflow: hidden;
}

.vip-hero-player-inner:fullscreen,
.vip-hero-player-inner:-webkit-full-screen {
  width: 100vw !important;
  height: 100vh !important;
  padding-bottom: 0 !important;
  border-radius: 0 !important;
  background: #000;
}

.vip-hero-player-inner.is-pseudo-fullscreen {
  position: fixed !important;
  inset: 0 !important;
  width: 100vw !important;
  height: 100vh !important;
  height: 100dvh !important;
  max-height: none !important;
  padding-bottom: 0 !important;
  border-radius: 0 !important;
  background: #000 !important;
  overflow: hidden !important;
  z-index: 2147483000 !important;
}

.vip-hero-player-inner iframe,
.vip-hero-player-inner .vip-hero-player-iframe-wrapper,
.vip-hero-player-inner .vip-hero-player-iframe-wrapper > div,
.vip-hero-player-iframe {
  position: absolute !important;
  inset: 0 !important;
  width: 100% !important;
  height: 100% !important;
  border: 0 !important;
  display: block !important;
  z-index: 100;
}

.vip-hero-player-inner:fullscreen iframe,
.vip-hero-player-inner:fullscreen .vip-hero-player-iframe-wrapper,
.vip-hero-player-inner:fullscreen .vip-hero-player-iframe-wrapper > div,
.vip-hero-player-inner:fullscreen .vip-hero-player-iframe,
.vip-hero-player-inner:-webkit-full-screen iframe,
.vip-hero-player-inner:-webkit-full-screen .vip-hero-player-iframe-wrapper,
.vip-hero-player-inner:-webkit-full-screen .vip-hero-player-iframe-wrapper > div,
.vip-hero-player-inner.is-pseudo-fullscreen iframe,
.vip-hero-player-inner.is-pseudo-fullscreen .vip-hero-player-iframe-wrapper,
.vip-hero-player-inner.is-pseudo-fullscreen .vip-hero-player-iframe-wrapper > div,
.vip-hero-player-inner.is-pseudo-fullscreen .vip-hero-player-iframe,
.vip-hero-player-inner:-webkit-full-screen .vip-hero-player-iframe {
  inset: 0 !important;
  width: 100% !important;
  height: 100% !important;
}

.vip-hero-fullscreen-btn {
  position: absolute;
  right: calc(env(safe-area-inset-right, 0px) + 12px);
  bottom: calc(env(safe-area-inset-bottom, 0px) + 86px);
  width: 34px;
  height: 34px;
  padding: 0;
  border: 0;
  border-radius: 18px;
  background: rgba(0, 0, 0, 0.3);
  color: rgba(255, 255, 255, 0.96);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 140;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.35);
  transition: background-color 0.2s ease, transform 0.2s ease, opacity 0.2s ease;
  -webkit-tap-highlight-color: transparent;
  opacity: 0;
  visibility: hidden;
  pointer-events: none;
}

.vip-hero-fullscreen-btn:hover {
  background: rgba(0, 0, 0, 0.4);
}

.vip-hero-fullscreen-btn:active {
  transform: scale(0.96);
}

.vip-hero-fullscreen-btn:focus-visible {
  outline: 2px solid rgba(255, 255, 255, 0.9);
  outline-offset: 2px;
}

.vip-hero-fullscreen-btn svg {
  width: 18px;
  height: 18px;
  display: block;
}

.vip-hero-fullscreen-btn.is-active {
  background: rgba(18, 18, 18, 0.72);
}

.vip-hero-fullscreen-btn.is-visible {
  opacity: 1;
  visibility: visible;
  pointer-events: auto;
}

/* Dynamic Background */
.vip-hero-bg {
  position: absolute;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center top;
  top: 0;
  left: 0;
}

/* Content */
.vip-hero-content {
  position: relative;
  z-index: 2;
  width: 100%;
  max-width: none;
  color: #fff;
}

@keyframes vip-hero-ai-hint-lifecycle {
  0% {
    opacity: 0;
    transform: translate3d(-10px, 8px, 0) scale(0.94);
  }
  13.64% {
    opacity: 1;
    transform: translate3d(0, -1px, 0) scale(1);
  }
  90.91% {
    opacity: 1;
    transform: translate3d(0, -1px, 0) scale(1);
  }
  100% {
    opacity: 0;
    transform: translate3d(14px, -10px, 0) scale(0.9);
  }
}
@keyframes vip-hero-ai-hint-glow {
  0%, 100% {
    text-shadow: 0 0 10px rgba(139, 92, 246, 0.28), 0 0 18px rgba(167, 139, 250, 0.16);
  }
  50% {
    text-shadow: 0 0 14px rgba(139, 92, 246, 0.52), 0 0 28px rgba(196, 181, 253, 0.36);
  }
}
@keyframes aiHintPulse {
  0%, 100% {
    transform: scale(1);
    opacity: 0.9;
  }
  50% {
    transform: scale(1.08);
    opacity: 1;
  }
}
@keyframes vip-hero-ai-hint-caret {
  0%, 100% {
    opacity: 0;
  }
  50% {
    opacity: 1;
  }
}
@keyframes vip-hero-ai-hint-fade-only {
  0% {
    opacity: 0;
  }
  13.64%, 90.91% {
    opacity: 0.96;
  }
  100% {
    opacity: 0;
  }
}
.vip-hero-ai-hint {
  position: absolute;
  left: 0;
  bottom: calc(100% + 10px);
  z-index: 3;
  display: inline-flex;
  align-items: center;
  gap: 12px;
  max-width: min(98vw, 1200px);
  font-size: clamp(12px, 1.2vw, 20px);
  font-weight: 600;
  line-height: 1.05;
  letter-spacing: 0.03em;
  text-transform: uppercase;
  white-space: nowrap;
  pointer-events: none;
  padding: 10px 14px;
  background: linear-gradient(to top, rgba(0, 0, 0, 0.9), rgba(0, 0, 0, 0.71), rgba(0, 0, 0, 0.45));
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 14px;
  box-shadow: 0 10px 28px rgba(0, 0, 0, 0.28), 0 0 0 1px rgba(167, 139, 250, 0.08);
  opacity: 0;
  transform: translate3d(-10px, 8px, 0) scale(0.94);
  will-change: opacity, transform;
  animation: vip-hero-ai-hint-lifecycle var(--homepage-ai-hint-total-ms, 300000ms) cubic-bezier(0.22, 1, 0.36, 1) forwards;
  overflow: hidden;
}

.vip-hero-ai-hint__pointer {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
  width: 30px;
  height: 30px;
  line-height: 0;
  margin-right: 8px;
}

.ai-tap-icon {
  display: block;
  width: 30px;
  height: 30px;
  background-color: #8b5cf6;
  vertical-align: -2px;
  mask-image: var(--ai-tap-icon-mask);
  mask-repeat: no-repeat;
  mask-position: center;
  mask-size: contain;
  filter: drop-shadow(0 0 3px rgba(139, 92, 246, 0.75)) drop-shadow(0 0 8px rgba(139, 92, 246, 0.35));
  animation: aiHintPulse 2.2s ease infinite;
}

.vip-hero-ai-hint__label {
  position: relative;
  display: inline-flex;
  align-items: center;
  overflow: hidden;
}

.vip-hero-ai-hint__label::after {
  content: "";
  position: absolute;
  top: 8%;
  bottom: 8%;
  right: 0;
  width: 2px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.95);
  box-shadow: 0 0 12px rgba(255, 255, 255, 0.45);
  opacity: 0;
  animation: vip-hero-ai-hint-caret 0.85s steps(1, end) infinite;
}

.vip-hero-ai-hint__label[data-empty=false]::after {
  opacity: 1;
}

.vip-hero-ai-hint__label-text {
  position: relative;
  display: inline-block;
  color: #ffffff;
  text-shadow: 0 0 16px rgba(255, 255, 255, 0.12), 0 0 24px rgba(139, 92, 246, 0.1);
  animation: vip-hero-ai-hint-glow 2.8s ease-in-out infinite;
}

.vip-hero-ai-hint__label-accent {
  position: relative;
  z-index: 1;
  color: #8b5cf6;
  text-shadow: 0 0 10px rgba(139, 92, 246, 0.55), 0 0 18px rgba(139, 92, 246, 0.22);
}

.vip-hero-ai-hint__label-rest {
  position: relative;
  z-index: 1;
  color: #ffffff;
}

@media (prefers-reduced-motion: reduce) {
  .vip-hero-ai-hint {
    animation: vip-hero-ai-hint-fade-only var(--homepage-ai-hint-total-ms, 300000ms) ease forwards;
    transform: none;
  }
  .vip-hero-ai-hint__pointer,
  .vip-hero-ai-hint__label,
  .vip-hero-ai-hint__label-text,
  .ai-tap-icon {
    animation: none;
  }
  .vip-hero-ai-hint__label::after,
  .vip-hero-ai-hint__label-text::after {
    animation: none;
    display: none;
  }
}
.vip-hero-content--mobile {
  position: relative;
  width: 100%;
  padding: 0 40px;
}

.vip-hero-title__comment {
  flex-shrink: 0;
}

.vip-hero-content--desktop {
  display: none;
}

@media (min-width: 801px) {
  .vip-hero-content--mobile {
    display: none;
  }
}
@media (min-width: 801px) {
  .vip-hero-content--desktop {
    display: block;
    position: absolute;
    top: var(--vip-hero-desktop-top, -85px);
    left: 0;
    right: 0;
    width: 100%;
    background: linear-gradient(to top, #000000 0%, rgba(0, 0, 0, 0.95) 15%, rgba(0, 0, 0, 0.75) 35%, rgba(0, 0, 0, 0.45) 60%, rgba(0, 0, 0, 0.15) 80%, rgba(0, 0, 0, 0) 100%);
    padding: 0 50px;
  }
  .vip-hero-title__comment--desktop {
    float: right;
    margin-left: 10px;
    margin-top: 2px;
    top: 0;
  }
}
@media (min-width: 1401px) {
  .vip-hero-content--desktop {
    padding: 5px 52px;
  }
}
@media (max-width: 800px) {
  .vip-hero-content--desktop {
    display: none;
  }
  .vip-hero-content--mobile {
    display: block;
    position: absolute;
    bottom: 8px;
    left: 0;
    right: 0;
    width: 100%;
    padding: 0 12px;
    z-index: 15;
  }
  .vip-hero-title {
    display: block;
  }
  .vip-hero-title__comment {
    float: right;
    margin-left: 8px;
    margin-top: 0;
    top: 0;
  }
  .vip-hero-title__text {
    display: block;
    min-width: 0;
  }
  .vip-hero-ai-hint {
    bottom: calc(100% + 8px);
    max-width: 98vw;
    gap: 8px;
    font-size: 9.5px;
    letter-spacing: 0.015em;
    padding: 8px 10px;
    border-radius: 8px;
  }
  .vip-hero-ai-hint__pointer {
    width: 18px;
    height: 18px;
  }
  .ai-tap-icon {
    width: 18px;
    height: 18px;
  }
}
.vip-hero-title {
  font-family: "Space Grotesk", sans-serif;
  font-size: 37.5px;
  font-weight: 500;
  line-height: 1.1;
  margin: 0;
  color: #f8f8f8;
  display: block;
  width: 100%;
  max-width: 100%;
  padding: 0;
  background: none;
  border: 0;
  border-radius: 0;
  text-decoration: none;
  text-shadow: 0 4px 18px rgba(0, 0, 0, 0.85);
}

.vip-hero-title__text {
  display: inline;
  text-decoration-line: underline;
  text-decoration-color: rgba(248, 248, 248, 0.65);
  text-decoration-thickness: 1px;
  text-underline-offset: 2px;
  transition: color 0.15s ease, text-decoration-color 0.15s ease, text-decoration-thickness 0.15s ease;
}

.vip-hero-title--clickable {
  cursor: pointer;
  transition: color 0.2s ease, text-shadow 0.2s ease;
}
.vip-hero-title--clickable:hover {
  color: #ffffff;
  text-shadow: 0 6px 22px rgba(0, 0, 0, 0.95);
}
.vip-hero-title--clickable:hover .vip-hero-title__text {
  color: #ffffff;
  text-decoration-color: #c084fc;
  text-decoration-thickness: 1.5px;
}
.vip-hero-title--clickable:active {
  text-shadow: 0 4px 18px rgba(0, 0, 0, 0.85);
}

.vip-hero-title--disabled {
  cursor: default;
}
.vip-hero-title--disabled:hover, .vip-hero-title--disabled:active {
  color: inherit;
  text-shadow: 0 4px 18px rgba(0, 0, 0, 0.85);
}
.vip-hero-title--disabled .vip-hero-title__text {
  color: inherit;
  text-decoration-color: rgba(248, 248, 248, 0.65);
  text-decoration-thickness: 1px;
}

.news-block__title--clickable {
  transition: color 0.15s ease;
}
.news-block__title--clickable:hover {
  color: #c084fc !important;
}
.news-block__title--clickable:hover u {
  color: #c084fc;
  text-decoration-color: #c084fc;
  text-decoration-thickness: 1.5px;
}

.vip-hero-play-btn {
  background-color: #4b3f5e;
  display: block;
  margin-left: var(--vip-row-gutter, 40px);
  border: none;
  padding: 12px 28px;
  color: white;
  font-size: 16px;
  border-radius: 6px;
  cursor: pointer;
  transition: 0.3s ease;
}

/* Desktop headline baseline stays fixed; AdaptiveHeadline can still shrink when needed */
@media (min-width: 769px) {
  .news-block__title {
    width: calc(100% - 2 * var(--vip-row-gutter, 40px));
    margin-left: var(--vip-row-gutter, 40px);
  }
}
@media (min-width: 801px) {
  .news-block__title {
    font-size: 32px !important;
    margin-bottom: 0px;
    letter-spacing: -0.02em;
  }
}
.vip-after-hero {
  --vip-full-bleed-overscan: 8px;
  width: calc(100vw + var(--vip-full-bleed-overscan));
  margin-left: calc(-50vw + 50% - var(--vip-full-bleed-overscan) / 2);
  position: relative;
  margin-top: calc(var(--vip-after-hero-overlap, 0px) * -1);
  z-index: 5;
  background: none;
  isolation: isolate;
}

.vip-after-hero::before {
  content: "";
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  height: clamp(180px, 28vw, 420px);
  background: linear-gradient(to top, rgb(0, 0, 0) 0%, rgba(0, 0, 0, 0.82) 28%, rgba(0, 0, 0, 0.48) 58%, rgba(0, 0, 0, 0.18) 80%, rgba(0, 0, 0, 0) 100%);
  pointer-events: none;
  z-index: -1;
}

.vip-after-hero-top-gap {
  display: none;
}

.slider-container.slider-row {
  transition: background 0.3s ease;
}

.vip-more-rows {
  display: flow-root;
  background: rgba(0, 0, 0, 0.5);
}

.slider-container.slider-row.first-row {
  padding-top: 20px !important;
  margin-bottom: 10px;
}

.vip-more-headlines-indicator {
  display: none;
  align-items: center;
  gap: 14px;
  color: rgba(255, 255, 255, 0.95);
  letter-spacing: 0.1em;
  text-transform: uppercase;
  font-size: 14px;
  font-weight: 700;
  margin: 10px var(--vip-row-gutter, 40px) 20px;
  text-shadow: 0 1px 10px rgba(0, 0, 0, 0.55);
}

.vip-more-headlines-indicator::before,
.vip-more-headlines-indicator::after {
  content: "";
  flex: 1 1;
  height: 2px;
  background: linear-gradient(90deg, rgba(255, 255, 255, 0.18), rgba(255, 255, 255, 0.6));
}

.vip-more-headlines-indicator::after {
  background: linear-gradient(90deg, rgba(255, 255, 255, 0.6), rgba(255, 255, 255, 0.18));
}

@media (min-width: 801px) {
  .vip-more-headlines-indicator {
    display: flex;
  }
}
@media (max-width: 1200px) {
  .slider-container.slider-row.first-row {
    margin-bottom: 0;
  }
}
@media (min-width: 801px) {
  .slider-container.slider-row.first-row {
    padding-top: var(--vip-first-row-top-padding, 84px) !important;
  }
}
.slider-container.slider-row:not(.first-row) {
  padding-top: 0 !important;
}

@media (min-width: 768px) {
  .vip-more-rows > .slider-container.slider-row + .slider-container.slider-row {
    margin-top: 4px;
  }
}
/* Screens smaller than 1400px */
@media (max-width: 1400px) {
  .vip-after-hero {
    padding: 0;
  }
}
/* Mobile */
@media (max-width: 800px) {
  .vip-after-hero {
    padding: 0;
  }
  .vip-after-hero::before {
    height: clamp(140px, 44vw, 260px);
  }
  .slider-container.slider-row {
    padding-left: var(--vip-row-gutter, 10px) !important;
    padding-right: var(--vip-row-gutter, 10px) !important;
  }
}
.new_livess {
  margin-top: 100px;
}
@media (max-width: 800px) {
  .new_livess {
    margin-top: 60px;
  }
}
.new_livess.has-player {
  margin-top: 100px;
}
@media (max-width: 800px) {
  .new_livess.has-player {
    margin-top: 60px;
  }
}

/* ===== LIVE TV PLAYER ===== */
.live-player-container {
  width: 100vw;
  margin-left: calc(-50vw + 50%);
  height: calc(100vh - 86px); /* Fills space between header and footer approximately */
  background: #000;
  position: relative;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

@media (min-width: 801px) {
  .live-player-container {
    margin-top: -100px;
  }
}
@media (max-width: 800px) {
  .live-player-container {
    margin-top: -60px;
  }
}
.live-player-wrapper {
  flex: 1 1;
  width: 100%;
  height: 100%;
  position: relative;
  background: #000;
}

.live-player-inner {
  width: 100%;
  height: 100%;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  /* SmartYouTubeEmbed uses a padding-bottom aspect-ratio trick;
     override it here so it fills the full live-player height */
}
.live-player-inner > div {
  position: absolute !important;
  inset: 0 !important;
  padding-bottom: 0 !important;
  width: 100% !important;
  height: 100% !important;
  border-radius: 0 !important;
}
.live-player-inner .yt-fill,
.live-player-inner .yt-iframe,
.live-player-inner iframe {
  position: absolute !important;
  inset: 0 !important;
  width: 100% !important;
  height: 100% !important;
  border: none !important;
}

.live-player-iframe,
.live-player-video {
  width: 100%;
  height: 100%;
  border: none;
  object-fit: contain;
}

.live-player-error {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  background: #111;
}

.live-stream-loader {
  position: absolute;
  inset: 0;
  z-index: 20;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: #0a0a0f;
  gap: 18px;
}
.live-stream-loader__spinner {
  width: 52px;
  height: 52px;
  border: 4px solid rgba(255, 255, 255, 0.12);
  border-top-color: #e63946;
  border-radius: 50%;
  animation: live-spin 0.85s linear infinite;
}
.live-stream-loader__label {
  font-size: 13px;
  font-weight: 500;
  letter-spacing: 0.06em;
  color: rgba(255, 255, 255, 0.55);
  text-transform: uppercase;
}
.live-stream-loader__dot-row {
  display: flex;
  gap: 6px;
}
.live-stream-loader__dot-row span {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #e63946;
  animation: live-dot-bounce 1.2s ease-in-out infinite;
}
.live-stream-loader__dot-row span:nth-child(2) {
  animation-delay: 0.2s;
}
.live-stream-loader__dot-row span:nth-child(3) {
  animation-delay: 0.4s;
}

@keyframes live-spin {
  to {
    transform: rotate(360deg);
  }
}
@keyframes live-dot-bounce {
  0%, 80%, 100% {
    transform: scaleY(1);
    opacity: 0.4;
  }
  40% {
    transform: scaleY(1.6);
    opacity: 1;
  }
}
.live-player-info {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  padding: 15px 25px;
  background: linear-gradient(transparent, rgba(0, 0, 0, 0.85));
  z-index: 10;
  pointer-events: none; /* Let clicks pass through to video if needed */
}
.live-player-info button {
  pointer-events: auto; /* Re-enable for close button */
}

.slider-container {
  padding: 0px !important;
}
@media (max-width: 768px) {
  .slider-container {
    padding: 0 25px !important;
  }
}

/* ===== RESET ===== */
/* ======= STICKY HEADER (navbar + breathing room) ===== */
.ds-header-sticky--overlay .ds-navbar {
  background: transparent;
}
.ds-header-sticky--overlay .ds-header-subfooter {
  background: transparent;
  border-bottom-color: transparent;
}

.ds-header-sticky {
  position: sticky;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 50;
}

/* ===== NAVBAR ===== */
.ds-navbar {
  --ds-navbar-height: 65px;
  width: 100%;
  height: var(--ds-navbar-height);
  padding: 0px 22px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: linear-gradient(to bottom, rgba(0, 0, 0, 0.9), rgba(0, 0, 0, 0.71));
}

.ds-header-subfooter {
  width: 100%;
  height: 0;
  overflow: hidden;
  opacity: 0;
  border-bottom: none;
  background: linear-gradient(to bottom, rgba(0, 0, 0, 0.62), rgba(0, 0, 0, 0.4));
  transition: height 0.2s ease, opacity 0.2s ease, border-color 0.2s ease;
}
.ds-header-subfooter.ds-header-subfooter--visible {
  height: 8px;
  opacity: 1;
  border-bottom: 1px solid rgba(255, 255, 255, 0.045);
}

/* ===== MENU WRAP ===== */
.ds-menu-wrap {
  display: grid;
  align-items: center;
  grid-template-columns: auto minmax(0, 1fr) auto;
  width: 100%;
  margin-left: 30px;
  flex: 1 1; /* allow it to grow/shrink */
  min-width: 0; /* avoid overflow */
  gap: 8px;
}

.ds-menu-primary,
.ds-menu-secondary {
  flex: 0 0 auto;
  min-width: 0;
}

.ds-menu-primary {
  justify-content: flex-start;
}

/* Event Country | Live | Global Country — equal side columns keep Live centered */
.ds-menu-mid-trio {
  display: inline-flex;
  margin: 0px 15px;
  grid-template-columns: 1fr auto 1fr;
  align-items: center;
  justify-content: space-between;
  width: 96%;
  min-width: 0;
}

.ds-menu-mid-trio__event {
  justify-self: end;
  min-width: 0;
  max-width: 34%;
}

.ds-menu-mid-trio__event > .ds-link,
.ds-menu-mid-trio__country > .ds-link {
  display: block;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.ds-menu-mid-trio__live {
  justify-self: center;
}

.ds-menu-mid-trio__country {
  justify-self: start;
  min-width: 0;
  max-width: 34%;
}

.ds-menu-secondary {
  justify-content: flex-end;
}

@media (max-width: 1400px) {
  .ds-menu-wrap {
    margin-left: 15px;
  }
}
/* responsive gap classes for header */
.ds-header-gap {
  gap: 24px; /* default gap-4 equivalent */
}

@media (max-width: 1400px) {
  .ds-header-gap {
    gap: 16px;
  }
}
@media (max-width: 1200px) {
  .ds-header-gap {
    gap: 12px;
  }
  .ds-menu-wrap {
    gap: 4px;
  }
}
@media (max-width: 1320px) {
  .ds-header-gap {
    gap: 10px;
  }
  .ds-menu-wrap {
    gap: 3px;
  }
  .ds-live-dropdown-toggle {
    min-width: auto;
  }
}
/* LEFT + RIGHT GROUP */
.ds-group {
  display: flex;
  align-items: center;
  gap: 28px;
}

/* ===== LINKS ===== */
.ds-link {
  color: rgba(255, 255, 255, 0.87);
  font-size: 18px;
  font-weight: 750;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  cursor: pointer;
  transition: 0.25s;
  white-space: nowrap;
}

@media (max-width: 1400px) {
  .ds-link {
    font-size: 16px;
  }
}
@media (max-width: 1200px) {
  .ds-link {
    font-size: 14px;
    letter-spacing: 0.03em;
  }
}
.ds-link:hover {
  color: rgba(255, 255, 255, 0.9);
}

.ds-live-dropdown-toggle {
  display: inline-flex;
  align-items: center;
  gap: 0.28rem;
  min-width: 4.75rem;
}

.ds-live-dropdown-toggle--full {
  display: flex;
  width: 100%;
  min-width: 0;
  justify-content: space-between;
  align-items: center;
}

.ds-live-dropdown-toggle--full .ds-live-dropdown-toggle__label {
  display: inline-flex;
  align-items: center;
  gap: 0.28rem;
  flex: 0 1 auto;
  min-width: 0;
}

.ds-live-dropdown-toggle__left {
  flex: 0 0 auto;
}

.ds-live-dropdown-toggle__right {
  flex: 0 0 auto;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  line-height: 1;
}

.ds-live-dropdown-toggle__caret {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: inherit;
  line-height: 1;
}

.ds-live-dropdown-toggle .ds-dropdown-icon {
  margin-left: 0;
}

.ds-live-indicator {
  display: block;
  flex-shrink: 0;
  width: 12px;
  height: 12px;
  margin-right: 3px;
  border-radius: 50%;
  background: #a970ff;
  box-shadow: 0 0 8px rgba(169, 112, 255, 0.7);
  animation: dsLivePulse 1.9s ease-in-out infinite;
}

@keyframes dsLivePulse {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.55;
  }
}
.ds-dropdown {
  position: relative;
}

.ds-dropdown-menu {
  position: absolute;
  top: 100%;
  left: 0;
  min-width: 170px;
  background-color: rgba(38, 30, 50, 0.8);
  backdrop-filter: blur(14px);
  border-radius: 14px;
  padding: 0;
  opacity: 0;
  pointer-events: none;
  transform: translateY(10px);
  transition: 0.25s ease;
  box-shadow: 0 18px 40px rgba(8, 6, 14, 0.32), 0 0 24px rgba(129, 108, 182, 0.08);
  z-index: 99999;
  border: 1px solid rgba(255, 255, 255, 0.08);
  max-height: calc(100vh - 92px) !important;
  overflow-y: auto !important;
  overflow-x: hidden;
  scrollbar-gutter: stable;
}

.ds-headlines-dropdown > .ds-dropdown-menu {
  min-width: 320px;
  max-width: 420px;
}

.ds-headlines-dropdown > .ds-link,
.ds-live-dropdown-toggle {
  font-size: 28px;
}

@media (max-width: 1140px) {
  .ds-headlines-dropdown > .ds-link,
  .ds-live-dropdown-toggle {
    font-size: 20px;
  }
}
@media (max-width: 1060px) {
  .ds-headlines-dropdown > .ds-link,
  .ds-live-dropdown-toggle {
    font-size: 16px;
  }
}
.ds-menu-mid-trio__event > .ds-link,
.ds-menu-mid-trio__country > .ds-link,
.ds-menu-secondary .ds-link {
  color: #D8D8E0;
  opacity: 0.9;
}

.ds-menu-mid-trio__event > .ds-link:hover,
.ds-menu-mid-trio__country > .ds-link:hover,
.ds-menu-secondary .ds-link:hover {
  color: #e4e4ea;
  opacity: 1;
}

.ds-headlines-dropdown .ds-dd-item {
  max-width: none;
}

@keyframes dsDrawerDown {
  from {
    opacity: 0;
    transform: translateY(-6px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
/* Align menu to the right if needed */
.ds-dropdown-right .ds-dropdown-menu {
  left: auto;
  right: 0;
}

.ds-dropdown:hover > .ds-dropdown-menu {
  opacity: 1;
  pointer-events: auto;
  transform: translateY(0);
}

/* 2nd level dropdown */
.ds-dropdown-nested {
  position: relative;
}

/* Nested category chevron: right when closed, down when expanded. */
.arrow {
  display: inline-block;
  transition: transform 0.2s ease;
  transform-origin: center;
}

.arrow.open {
  transform: rotate(90deg);
}

.ds-second-level-menu {
  margin: 6px 0 10px 14px;
  padding: 6px 0 6px 12px;
  border-left: 1px solid rgba(255, 255, 255, 0.12);
  max-height: 320px;
  overflow-y: auto;
  animation: dsDrawerDown 0.18s ease;
}

.ds-second-level-menu .ds-dd-item {
  padding: 8px 12px;
  font-size: 13px;
  font-weight: 650;
  letter-spacing: 0.02em;
  text-transform: none;
  opacity: 0.92;
}

.ds-dd-item {
  display: block;
  padding: 12px 18px;
  color: rgba(255, 255, 255, 0.92);
  font-size: 16px;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  line-height: 1.35;
  text-decoration: none;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  cursor: pointer;
  max-width: 450px; /* prevent ultra wide menus */
}

@media (max-width: 1400px) {
  .ds-dd-item {
    font-size: 14px;
    padding: 10px 14px;
  }
}
.ds-dd-item:last-child {
  border-bottom: none;
}

.ds-dd-item:hover {
  background: rgba(255, 255, 255, 0.08);
  color: #fff;
}

/* Explicit color prevents Bootstrap's .text-muted or inherited theme colors
   from making the first language option unreadable on the dark menu. */
.ds-dd-item--all {
  color: rgba(255, 255, 255, 0.76) !important;
}

.ds-dd-item--all:hover {
  color: #fff !important;
}

/* Persistent feedback after a category/subcategory is selected. */
.ds-dd-item--selected {
  color: #c084fc !important;
  background: rgba(124, 58, 237, 0.16);
}

.ds-dd-item--selected:hover {
  color: #d8b4fe !important;
  background: rgba(124, 58, 237, 0.22);
}

.news-block__title u {
  text-decoration-line: underline;
  text-decoration-color: rgba(244, 244, 246, 0.55);
  text-decoration-thickness: 1px;
  text-underline-offset: 4px;
  transition: color 0.15s ease, text-decoration-color 0.15s ease, text-decoration-thickness 0.15s ease;
}

@media (max-width: 768px) {
  .news-block__title u {
    text-underline-offset: 2px;
  }
}
/* ===== MOBILE TOGGLE ===== */
.ds-toggle-btn {
  display: none;
  font-size: 26px;
  background: none;
  border: none;
  color: #fff;
  cursor: pointer;
}

@media (max-width: 1000px) {
  /* ===== SIDEBAR ===== */
  .ds-sidebar {
    position: fixed;
    inset: 0 auto 0 0;
    width: 82%;
    max-width: 320px;
    background-color: #4b3f5e;
    padding: 20px 18px;
    transform: translateX(-100%);
    transition: transform 0.25s cubic-bezier(0.4, 0, 0.2, 1);
    z-index: 200;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    box-shadow: 20px 0 40px rgba(0, 0, 0, 0.6);
  }
  .ds-sidebar.open {
    transform: translateX(0);
  }
  /* ===== CLOSE BUTTON ===== */
  .ds-close {
    position: absolute;
    left: 14px;
    top: 12px;
    font-size: 24px;
    color: #fff;
    opacity: 0.8;
    background: none;
  }
  /* ===== LINKS ===== */
  .ds-sidebar .ds-link {
    font-size: 15px;
    font-weight: 700;
    letter-spacing: 0.03em;
    padding: 12px 0;
    border-bottom: 1px solid rgba(255, 255, 255, 0.08);
  }
  /* ===== DROPDOWN ===== */
  .ds-dd-item {
    padding: 10px 10px;
    border-radius: 10px;
    margin: 4px 0;
    transition: background 0.25s ease, transform 0.2s ease;
    font-size: 13px;
    line-height: 1.3;
    letter-spacing: 0.02em;
  }
  .ds-dd-item:active {
    background: rgba(255, 255, 255, 0.08);
  }
  /* ===== SECOND LEVEL ===== */
  .ds-second-level {
    margin-left: 10px;
    padding-left: 10px;
    border-left: 1px solid rgba(255, 255, 255, 0.08);
    animation: slideDown 0.35s ease;
  }
  .ds-dd-item.sub {
    font-size: 12px;
    opacity: 0.85;
  }
  /* ===== HEADLINES DROPDOWN ICON ===== */
  /* Dropdown arrow rotation */
  .ds-dropdown-icon {
    font-size: 12px;
    opacity: 0.8;
    margin-left: 6px;
    transition: transform 0.25s ease;
  }
  .ds-dropdown-icon.open {
    transform: rotate(180deg);
  }
  .ds-sidebar .ds-dropdown {
    position: relative;
  }
  /* ===== HEADLINES DROPDOWN WIDTH ===== */
  .ds-sidebar .ds-dropdown-menu {
    position: relative;
    top: auto;
    left: auto;
    transform: none;
    width: 100%;
    margin-top: 6px;
    padding-left: 6px;
    background: transparent;
    box-shadow: none;
    display: block;
    min-width: 0;
    max-width: 100%;
    padding-right: 8px;
    opacity: 1;
    pointer-events: auto;
    max-height: calc(100vh - 180px) !important;
    overflow-y: auto !important;
    animation: mobileDropdownIn 0.24s ease;
    transform-origin: top left;
  }
  /* ===== ARROW ===== */
  .arrow {
    transition: transform 0.3s ease;
    font-size: 14px;
  }
  .arrow.open {
    transform: rotate(90deg);
  }
  /* ===== OVERLAY ===== */
  .ds-overlay {
    position: fixed;
    inset: 0;
    background: rgba(0, 0, 0, 0.55);
    /* backdrop-filter: blur(4px); */ /* 🔥 performance hog on mobile */
    animation: fadeIn 0.2s ease;
    z-index: 150;
  }
  /* Optional smooth slide for menu open */
  .ds-second-level {
    animation: slideDown 0.3s ease;
  }
  @keyframes slideDown {
    from {
      opacity: 0;
      transform: translateY(-5px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
  /* ===== ANIMATIONS ===== */
  @keyframes slideDown {
    from {
      opacity: 0;
      transform: translateY(-6px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
  @keyframes fadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
  @keyframes mobileDropdownIn {
    from {
      opacity: 0;
      transform: translateY(-6px) scaleY(0.98);
    }
    to {
      opacity: 1;
      transform: translateY(0) scaleY(1);
    }
  }
}
/* ===== DESKTOP: SIDEBAR COMPLETELY OFF ===== */
@media (min-width: 1001px) {
  .ds-sidebar,
  .ds-overlay {
    display: none !important;
  }
}
/* ===== RESPONSIVE ===== */
@media (max-width: 1000px) {
  .ds-header-subfooter {
    display: none;
  }
  .ds-menu-wrap {
    display: none;
  }
  .mobile-menu-wrap {
    margin-top: 55px !important;
  }
  .ds-logo-link {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    justify-self: center;
    align-self: center;
    height: 100%;
    max-width: calc(100% - 92px);
  }
  .ds-logo-img {
    height: 56px;
    width: auto;
    max-width: min(220px, 100vw - 96px);
    align-self: normal;
  }
  .ds-dropdown-menu {
    top: 1%;
  }
  .ds-navbar {
    position: relative;
    display: flex;
    --ds-navbar-height: 45px;
    align-items: center;
    justify-content: flex-end;
    padding: 0 12px;
  }
  .ds-toggle-btn {
    display: inline-flex;
    position: relative;
    z-index: 3;
    align-self: stretch;
    left: 12px;
    top: 5px;
    align-items: center;
    justify-content: right;
    min-width: 51px;
    height: 85%;
    margin: 0;
    padding: 0;
    font-size: 27px;
    line-height: 1;
  }
}
body.mobile-hero-pseudo-fullscreen {
  background: #000;
}

body.mobile-hero-pseudo-fullscreen .ds-header-sticky,
body.mobile-hero-pseudo-fullscreen .ds-footer {
  opacity: 0 !important;
  visibility: hidden !important;
  pointer-events: none !important;
}

@media screen and (max-width: 800px) {
  .trending-scroll--vip-mobile-playing {
    height: calc(100dvh - 56px - 20px);
    overflow: hidden;
    display: flex;
    flex-direction: column;
    padding-left: 0 !important;
    padding-right: 0 !important;
  }
  body.mobile-hero-pseudo-fullscreen .trending-scroll--vip-mobile-playing {
    height: 100vh !important;
    height: 100dvh !important;
    overflow: visible !important;
  }
  .trending-scroll--vip-mobile-playing .vip-hero {
    position: sticky;
    top: 0;
    z-index: 25;
    flex: 0 0 auto;
  }
  body.mobile-hero-pseudo-fullscreen .trending-scroll--vip-mobile-playing .vip-hero {
    position: static !important;
    top: auto !important;
  }
  .trending-scroll--vip-mobile-playing .vip-after-hero {
    flex: 1 1 auto;
    min-height: 0;
    overflow-y: auto;
    overflow-x: hidden;
    -webkit-overflow-scrolling: touch;
    overscroll-behavior: contain;
  }
  .vip-hero {
    position: relative;
    height: auto;
    aspect-ratio: 16/9;
    align-items: stretch;
    overflow: hidden;
  }
  .vip-hero:not(.vip-hero--is-playing) {
    aspect-ratio: 16/8.6;
  }
  .vip-hero.vip-hero--is-playing {
    height: auto;
    aspect-ratio: auto;
  }
  .vip-hero-bg {
    object-fit: cover;
    object-position: center 2.8%;
  }
  .vip-hero:not(.vip-hero--is-playing) .vip-hero-bg {
    object-position: center 2.8%;
  }
  .ds-footer-content {
    justify-content: center !important;
  }
  .vip-hero-content--desktop {
    display: none !important;
  }
  .vip-hero-content--mobile {
    display: block !important;
    position: absolute !important;
    bottom: 0px !important;
    left: 0 !important;
    right: 0 !important;
    width: 100% !important;
    max-width: none !important;
    background: linear-gradient(to top, #000000 0%, rgba(0, 0, 0, 0.95) 15%, rgba(0, 0, 0, 0.75) 35%, rgba(0, 0, 0, 0.45) 60%, rgba(0, 0, 0, 0.15) 80%, rgba(0, 0, 0, 0) 100%);
    z-index: 15 !important;
    margin: 0 !important;
    padding: 0 12px !important;
    line-height: 20px !important;
  }
  .trending-scroll--vip-mobile-playing .vip-after-hero {
    margin-top: 0;
    padding: 0 0 12px;
    background: rgba(0, 0, 0, 0.72);
  }
  .trending-scroll--vip-mobile-playing .vip-after-hero-top-gap {
    display: block;
    height: 4px;
    position: sticky;
    top: 0;
    z-index: 2;
    background: rgb(0, 0, 0);
  }
  .app-main-with-footer.app-main-with-footer--footer-hidden .trending-scroll--vip-mobile-playing {
    height: calc(100dvh - 56px);
  }
  .slider-container.slider-row.first-row {
    padding-top: 0 !important;
    margin-bottom: 0;
  }
  .vip-hero-title {
    font-family: "Space Grotesk", sans-serif;
    font-size: 16px !important;
    line-height: 20px !important;
    padding: 2px 6px !important;
    margin-bottom: 2px;
    border-radius: 8px;
  }
  .news-block__title {
    font-size: 16.8px !important;
  }
  .vip-hero-play-btn {
    padding: 8px 18px;
  }
  .vip-hero {
    position: relative;
    cursor: pointer;
  }
  .vip-hero-play-btn-overlay {
    position: absolute;
    inset: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(0, 0, 0, 0.15);
    z-index: 10;
    pointer-events: auto;
  }
  .vip-hero-play-icon {
    width: 58px;
    height: 58px;
    border-radius: 50%;
    background: rgba(0, 0, 0, 0.42);
    border: 2px solid rgba(255, 255, 255, 0.72);
    display: flex;
    align-items: center;
    justify-content: center;
    color: #ffffff;
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.4);
    transition: transform 0.2s ease, background-color 0.2s ease;
    -webkit-tap-highlight-color: transparent;
  }
  .vip-hero-play-icon .play-glyph {
    width: 20px;
    height: 40px;
    margin-left: 5px;
    transform: scale(0.86);
  }
  .vip-hero-play-icon:active {
    transform: scale(0.92);
    background: rgba(111, 94, 168, 0.95);
  }
}
.app-main-with-footer {
  --footer-height: 31px;
  --footer-top-fade: 48px;
  --footer-safe-gap: 24px;
  --vip-after-hero-overlap: 0px;
  --vip-overlap-bottom-offset: 2px;
  --vip-first-row-top-padding: 84px;
  padding-bottom: var(--footer-safe-gap) !important;
}

/* ===== FOOTER ===== */
@media (max-width: 768px) {
  .ds-footer {
    background: #000 !important;
    height: 20px !important;
  }
}
.ds-footer {
  position: relative;
  bottom: auto;
  left: auto;
  width: 100%;
  height: var(--footer-height, 40px);
  background: linear-gradient(to bottom, rgba(8, 8, 12, 0.9), rgba(8, 8, 12, 0.86));
  z-index: 999;
  display: flex;
  align-items: center;
  isolation: isolate;
  overflow: visible;
  transition: transform 0.28s ease, opacity 0.28s ease, visibility 0.28s ease;
}

.ds-footer--hidden {
  transform: translateY(100%);
  opacity: 0;
  visibility: hidden;
  pointer-events: none;
}

.ds-footer--hidden::before {
  opacity: 0;
}

body:has(.ds-footer--hidden) .app-main-with-footer {
  padding-bottom: var(--footer-safe-gap, 24px) !important;
}

.app-main-with-footer.app-main-with-footer--footer-hidden {
  padding-bottom: 0 !important;
}

body:has(.ds-footer--hidden) .app-main-with-footer.app-main-with-footer--footer-hidden {
  padding-bottom: 0 !important;
}

.ds-footer::after {
  content: "▾";
  position: absolute;
  left: 8px;
  top: 45%;
  transform: translateY(-50%);
  font-size: calc(var(--footer-height, 31px) * 1.45);
  font-weight: 950;
  line-height: var(--footer-height, 31px);
  height: var(--footer-height, 31px);
  width: calc(var(--footer-height, 31px) * 1);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #ffffff;
  text-shadow: 0 0 8px rgba(255, 255, 255, 0.75), 0 0 18px rgba(125, 211, 252, 0.65), 0 0 28px rgba(59, 130, 246, 0.55);
  pointer-events: none;
  animation: ds-scroll-attention 0.85s ease-in-out infinite;
  transition: opacity 0.22s ease, visibility 0.22s ease;
}

@media (max-width: 768px) {
  .ds-footer::after {
    left: -4px;
  }
}
.ds-footer--scroll-end::after {
  opacity: 0;
  visibility: hidden;
  animation: none;
}

.ds-footer::before {
  content: "";
  position: absolute;
  left: 0;
  right: 0;
  bottom: 100%;
  height: var(--footer-top-fade, 48px);
  pointer-events: none;
  background: linear-gradient(to top, rgba(75, 63, 94, 0) 0%, rgba(32, 27, 42, 0.14) 45%, rgba(32, 27, 42, 0) 100%);
}

/* Footer: stronger bar on mobile (≤800px); lighter / less smoked on desktop (>800px) */
@media (min-width: 801px) {
  .ds-footer {
    background: linear-gradient(to bottom, rgba(22, 20, 32, 0.62), rgba(22, 20, 32, 0.5));
  }
  .ds-footer::before {
    background: linear-gradient(to top, rgba(75, 63, 94, 0) 0%, rgba(32, 27, 42, 0.06) 45%, rgba(32, 27, 42, 0) 100%);
  }
}
@keyframes ds-scroll-attention {
  0%, 100% {
    opacity: 0.35;
  }
  50% {
    opacity: 1;
  }
}
/* content align right */
.ds-footer-content {
  position: relative;
  z-index: 1;
  width: 100%;
  display: flex;
  justify-content: flex-end;
  padding: 0 40px;
}

.ds-footer-right {
  display: flex;
  gap: 20px;
}

@media (min-width: 801px) {
  .ds-footer-right {
    position: relative;
    display: inline-flex;
    align-items: center;
    gap: 20px;
    padding: 6px 14px;
    isolation: isolate;
  }
  .ds-footer-right::before {
    content: "";
    position: absolute;
    inset: 0;
    border-radius: inherit;
    background: rgba(12, 10, 18, 0.24);
    backdrop-filter: blur(5px);
    box-shadow: 0 0 0 1px rgba(255, 255, 255, 0.06), 0 8px 22px rgba(0, 0, 0, 0.2);
    z-index: -1;
    pointer-events: none;
  }
  .ds-footer-right a {
    position: relative;
    z-index: 1;
  }
}
@media (max-width: 1400px) {
  .ds-footer-content {
    padding: 0 20px;
  }
}
@media (max-width: 800px) {
  .ds-footer-content {
    padding: 0 10px;
  }
}
/* links style */
.ds-footer-right a {
  color: #fff;
  font-size: 13px;
  text-decoration: none;
  transition: 0.2s;
  font-weight: bolder;
}

@media (max-width: 800px) {
  .ds-footer-right a {
    font-size: 11px;
  }
}
.ds-footer-right a:hover {
  color: #7dd3fc;
  text-decoration: underline;
}

/* CSS triangle — Safari draws a grey box around the ▶ character */
.play-glyph {
  display: block;
  width: 22px;
  height: 26px;
  background: currentColor;
  clip-path: polygon(0 22%, 100% 50%, 0 78%);
  flex-shrink: 0;
}

.play-btn {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  -webkit-tap-highlight-color: transparent;
}
.play-btn .play-glyph {
  width: 32px;
  height: 38px;
  filter: drop-shadow(0 2px 8px rgba(0, 0, 0, 0.45));
}

@media (max-width: 800px) {
  .play-btn .play-glyph {
    width: 14px;
    height: 17px;
  }
}
/* ── Engagement bar (likes / dislikes / comments) ─────────────────────────── */
.engagement-bar {
  display: inline-flex;
  vertical-align: middle;
  align-items: center;
  gap: 6px;
  padding: 5px 2px 2px;
  margin-top: 4px;
}

.engagement-btn {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 999px;
  padding: 4px 10px 4px 8px;
  cursor: pointer;
  transition: background 0.15s, border-color 0.15s, transform 0.12s;
  color: #64748b;
  font-size: 0.8rem;
  font-weight: 600;
  line-height: 1;
}

.engagement-btn:hover {
  background: rgba(99, 102, 241, 0.12);
  border-color: rgba(99, 102, 241, 0.3);
  color: #94a3b8;
  transform: scale(1.05);
}

.engagement-btn--active-like {
  background: rgba(34, 197, 94, 0.1);
  border-color: rgba(34, 197, 94, 0.35);
  color: #4ade80;
}

.engagement-btn--active-dislike {
  background: rgba(239, 68, 68, 0.1);
  border-color: rgba(239, 68, 68, 0.3);
  color: #f87171;
}

.engagement-btn--comment {
  margin-left: 4px;
}

.engagement-btn--comment:hover {
  background: rgba(99, 102, 241, 0.14);
  border-color: rgba(99, 102, 241, 0.35);
  color: #a5b4fc;
}

.engagement-icon {
  font-size: 0.85rem;
  line-height: 1;
}

.engagement-count {
  font-size: 0.78rem;
  font-weight: 700;
  min-width: 14px;
}

/* Engagement bar under headline tweak */
.headline-and-engagement {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  align-items: start;
  column-gap: 10px;
  width: 100%;
  box-sizing: border-box;
  padding-left: var(--vip-row-gutter, 40px);
  padding-right: 6px;
  margin-bottom: 2px;
}

.headline-and-engagement .news-block__title {
  width: auto !important;
  min-width: 0;
  grid-column: 1;
  grid-row: 1;
  margin: 0 !important;
}

.headline-and-engagement__comment {
  grid-column: 2;
  grid-row: 1;
  justify-self: end;
  align-self: start;
  flex-shrink: 0;
  margin-left: 0;
  margin-top: 0;
  top: 0;
}

@media (max-width: 800px) {
  .headline-and-engagement {
    display: block;
    padding-left: 12px;
    padding-right: 0;
  }
  .headline-and-engagement::after {
    content: "";
    display: block;
    clear: both;
  }
  .headline-and-engagement .news-block__title {
    display: block;
    width: auto !important;
  }
  .headline-and-engagement__comment {
    float: right;
    margin-left: 8px;
  }
}
.engagement-bar {
  margin-top: 2px !important;
  padding-left: 0 !important;
}

@keyframes brightBlink {
  0% {
    opacity: 0.85;
    filter: drop-shadow(0 0 2px rgba(255, 255, 255, 0.5));
    transform: scale(1);
  }
  50% {
    opacity: 1;
    filter: drop-shadow(0 0 10px #fff) drop-shadow(0 0 18px #c084fc);
    transform: scale(1.22);
    color: #fff;
  }
  100% {
    opacity: 0.85;
    filter: drop-shadow(0 0 2px rgba(255, 255, 255, 0.5));
    transform: scale(1);
  }
}
.blinking-comment-icon {
  animation: brightBlink 1.4s infinite ease-in-out;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #e6d7ff;
  vertical-align: baseline;
  margin-left: 6px;
  padding: 0;
  border: 0;
  background: transparent;
  font: inherit;
  cursor: pointer;
  transform-origin: center;
  position: relative;
  top: 2px;
}

@media (max-width: 800px) {
  .blinking-comment-icon {
    margin-left: 0px;
  }
  .blinking-comment-icon::before {
    content: "";
    position: absolute;
    inset: -16px;
    min-width: 44px;
    min-height: 44px;
  }
}
.blinking-comment-icon .comment-bubble-svg {
  width: 12px;
  height: 12px;
  fill: none;
  stroke: currentColor;
  stroke-width: 1.8;
  stroke-linejoin: round;
}

.blinking-comment-icon .count {
  font-size: 13px;
  font-weight: 800;
  margin-left: 3px;
}

.blinking-comment-icon:focus-visible {
  outline: 2px solid rgba(196, 181, 253, 0.9);
  outline-offset: 3px;
  border-radius: 4px;
}

@media (min-width: 801px) {
  .blinking-comment-icon .comment-bubble-svg {
    width: 24px;
    height: 24px;
  }
  .blinking-comment-icon .count {
    font-size: 15px;
  }
}
.modal-chunk-loading-backdrop {
  position: fixed;
  inset: 0;
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  background: rgba(10, 8, 19, 0.72);
  backdrop-filter: blur(6px);
}

.modal-chunk-loading-card {
  padding: 14px 18px;
  border: 1px solid rgba(167, 139, 250, 0.28);
  border-radius: 10px;
  background: #171120;
  color: #ddd6fe;
  font: 600 14px/1.3 "Space Grotesk", sans-serif;
}

/* Last-resort guard so malformed AI output cannot crash the entire React tree. */
.analysis-render-error-backdrop {
  position: fixed;
  inset: 0;
  z-index: 10000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  background: rgba(10, 8, 19, 0.82);
  backdrop-filter: blur(8px);
}

.analysis-render-error-card {
  width: min(92vw, 520px);
  padding: 24px;
  border: 1px solid rgba(167, 139, 250, 0.28);
  border-radius: 16px;
  background: #171120;
  color: #f5f3ff;
  font-family: "Space Grotesk", sans-serif;
  box-shadow: 0 24px 80px rgba(0, 0, 0, 0.55);
}

.analysis-render-error-card h2 {
  margin: 0 0 10px;
  color: #c4b5fd;
  font-family: "Orbitron", "Space Grotesk", sans-serif;
  font-size: 18px;
}

.analysis-render-error-card p {
  margin: 0 0 18px;
  color: rgba(245, 243, 255, 0.8);
  line-height: 1.5;
}

.analysis-render-error-card button {
  border: 1px solid rgba(196, 181, 253, 0.45);
  border-radius: 8px;
  padding: 8px 16px;
  background: rgba(124, 58, 237, 0.2);
  color: #fff;
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/App.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAChB;EACE,oCAAA;EACA,WAAA;EACA,8CAAA;EACA,kBAAA;EACA,0CAAA;AACF;;AAEA,iCAAA;AAEA;EACE,mBAAA;EACA,oBAAA;EACA,mBAAA;AAAF;;AAGA;EACE,mBAAA;AAAF;;AAGA,YAAA;AACA;EACE,qBAAA;EACA,6BAAA;AAAF;;AAGA;EACE,eAAA;EACA,cAAA;EACA,mBAAA;AAAF;;AAGA;EACE,kBAAA;AAAF;;AAGA;EACE,cAAA;EACA,oBAAA;AAAF;;AAGA;EACE;IACE,4CAAA;EAAF;AACF;AAGA;EACE,yBAAA;EACA,iBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,6BAAA;EACA,YAAA;AADF;;AAIA;EACE,cAAA;AADF;;AAIA;EACE;IACE,uBAAA;EADF;EAIA;IACE,yBAAA;EAFF;AACF;AAKA;EACE,sBAAA;EACA,WAAA;EACA,YAAA;AAHF;;AAMA;EACE,yBAAA;EACA,YAAA;EACA,+BAAA;AAHF;;AAMA;EACE,sBAAA;EACA,UAAA;AAHF;;AAMA;;EAEE,WAAA;AAHF;;AAMA;EACE,cAAA;EACA,qBAAA;AAHF;;AAMA;EACE,0BAAA;AAHF;;AAMA;EACE,6BAAA;EACA,WAAA;EACA,YAAA;EACA,oCAAA;AAHF;;AAMA;EACE,WAAA;EACA,gCAAA;AAHF;;AAMA;EACE,WAAA;EACA,YAAA;AAHF;;AAMA;EACE,sBAAA;EACA,WAAA;EACA,qBAAA;AAHF;;AAMA;EACE,qBAAA;EACA,wBAAA;EACA,kBAAA;EACA,gCAAA;AAHF;;AAMA;EACE,sBAAA;EACA,wBAAA;EACA,kBAAA;EACA,gCAAA;AAHF;;AAMA;EACE,gBAAA;EACA,gBAAA;EACA,cAAA;AAHF;;AAMA;gFAAA;AAEA;EACE,kBAAA;EACA,mBAAA;EACA,2BAAA;EACA,WAAA;EACA,wBAAA;EACA,mBAAA;EACA,uBAAA;EACA,wFAAA;EACA,uBAAA;EACA,iBAAA;EACA,UAAA;EACA,YAAA;EACA,2CAAA;EACA,uBAAA;EACA,yBAAA;EACA,eAAA;EACA,aAAA;EAEA,gBAAA;EACA,wCAAA;AAHF;;AAMA;;EAEE,wBAAA;EACA,wBAAA;AAHF;;AAMA;EACE,kBAAA;EACA,uFAAA;AAHF;;AAMA;EACE,mBAAA;EACA,sFAAA;AAHF;;AAMA;EACE,cAAA;EACA,WAAA;EACA,8BAAA;EACA,iBAAA;EACA,UAAA;EACA,iDAAA;EACA,sEAAA;EACA,oBAAA;AAHF;;AAMA;EACE,sBAAA;AAHF;;AAMA;EACE,uBAAA;AAHF;;AAMA;EACE,2CAAA;EACA,oBAAA;AAHF;;AAMA;EACE,eAAA;EACA,2CAAA;AAHF;;AAMA;EACE;IACE,sBAAA;IACA,wBAAA;IACA,sCAAA;EAHF;EAMA;IACE,qBAAA;IACA,wBAAA;IACA,UAAA;EAJF;EAOA;IACE,sBAAA;IACA,iBAAA;IACA,0CAAA;EALF;EAQA;IACE,uEAAA;IACA,sFAAA;EANF;EASA;IACE,wEAAA;IACA,qFAAA;EAPF;EAUA;IACE,8BAAA;EARF;EAWA;IACE,gBAAA;IACA,gBAAA;EATF;AACF;AAYA;EACE,gBAAA;EACA,kBAAA;AAVF;;AAaA,+CAAA;AAEA;EACE,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,4BAAA;EACA,YAAA;EACA,gCAAA;EACA,aAAA;EACA,yBAAA;EACA,kBAAA;AAXF;;AAcA;EACE,cAAA;EACA,mBAAA;EACA,wBAAA;AAXF;;AAcA;EACE,sBAAA;EACA,4BAAA;AAXF;;AAcA,oEAAA;AAEA,6EAAA;AAEA;EACE,eAAA;EACA,gBAAA;AAbF;;AAgBA;EACE,mBAAA;EACA,kBAAA;AAbF;;AAkBA;EACE,sBAAA;AAfF;;AAoBA;EACE,0BAAA;AAjBF;;AAoBA,mBAAA;AAMA,uDAAA;AACA;EACE,cAAA;EACA,oBAAA;EACA,mBAAA;EACA,qBAAA;EACA,UAAA;EACA,eAAA;AAtBF;AAwBE;EAEE,aAAA;AAvBJ;;AA2BA;EACE,qCAAA;EACA,WAAA;EACA,mBAAA;EACA,cAAA;AAxBF;;AA2BA;EACE;IACE,YAAA;IACA,iBAAA;EAxBF;AACF;AA2BA,UAAA;AACA;EACE,gCAAA;EAEA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,yBAAA;AA1BF;;AA6BA;EACE,+BAAA;AA1BF;;AA6BA,eAAA;AACA;EACE,+BAAA;AA1BF;;AAyCA;EACE,2BAAA;AAtCF;;AAyCA,eAAA;AACA;EACE;IACE,mBAAA;EAtCF;EAyCA;IACE,gBAAA;IACA,eAAA;EAvCF;AACF;AA0CA,mCAAA;AACA;EACE;4EAAA;EAEA,kBAAA;EACA,WAAA;EACA,kBAAA;EACA,uEAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,UAAA;AAxCF;;AA2CA;EACE,uBAAA;EACA,YAAA;EACA,gBAAA;AAxCF;;AA2CA;EACE,mCAAA;EACA,uCAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;EACA,gBAAA;EACA,yBAAA;EACA,qDAAA;EACA,kBAAA;EACA,gBAAA;AAxCF;AA0CE;EAZF;IAaI,mCAAA;IACA,mBAAA;EAvCF;AACF;;AA0CA;EACE,cAAA;EACA,UAAA;EACA,2BAAA;EACA,oDAAA;AAvCF;;AA0CA;EAAwB,qBAAA;AAtCxB;;AAuCA;EAAwB,qBAAA;AAnCxB;;AAoCA;EAAwB,qBAAA;AAhCxB;;AAkCA;EACE;IACE,kFACE;EAhCJ;EAmCA;IACE,sHACE;EAlCJ;AACF;AAuCA;EACE;IACE,UAAA;IACA,2BAAA;EArCF;EAuCA;IACE,UAAA;IACA,wBAAA;EArCF;AACF;AAwCA;EACE;IACE,eAAA;IACA,kFACE;EAvCJ;AACF;AA2CA,0BAAA;AACA;EACE,WAAA;EACA,YAAA;EACA,0CAAA;EACA,6BAAA;EACA,kBAAA;EACA,oCAAA;AAzCF;;AA4CA,cAAA;AACA;EACE;IACE,yBAAA;EAzCF;AACF;AA6CA,YAAA;AAEA;EACE,yBAAA;AA5CF;;AA+CA,kCAAA;AACA;EACE,aAAA;AA5CF;;AA+CA,cAAA;AACA;EACE,mBAAA;EACA,gBAAA;EACA,mBAAA;EACA,uDACE;AA7CJ;;AAiDA;EACE,sBAAA;EACA,2CAAA;AA9CF;;AAiDA,sCAAA;AACA;EACE,yBAAA;AA9CF;;AAiDA,mBAAA;AACA;;EAEE,UAAA;AA9CF;;AAiDA;;EAEE,wBAAA;EACA,wBAAA;AA9CF;;AAiDA,4BAAA;AACA;EACE;IACE,sBAAA;EA9CF;AACF;AAiDA;EACE,kBAAA;EACA,kGAAA;EACA,kBAAA;EACA,uDAAA;EACA,uBAAA;EACA,qCAAA;EACA,wBAAA;EACA,mBAAA;EACA,8BAAA;EACA,kBAAA;EACA,2BAAA;EACA,2BAAA;EACA,uBAAA;EACA,wBAAA;EAEA,yCAAA;EAEA,iBAAA;EACA,mBAAA;AAjDF;;AAoDA;EACE,cAAA;EACA,WAAA;EACA,sBAAA;EACA,SAAA;EACA,cAAA;EACA,wCAAA;EACA,0BAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,iBAAA;AAjDF;;AAyDA;EACE;IACE,iBAAA;IACA,mBAAA;EAtDF;AACF;AAyDA;EACE,8BAAA;EACA,gBAAA;EACA,mDAAA;EACA,mEAAA;EACA,aAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;AAvDF;;AA2DA;EACE,kBAAA;EACA,WAAA;EACA,sBAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;AAxDF;;AA2DA;;EAEE,uBAAA;EACA,wBAAA;EACA,4BAAA;EACA,2BAAA;EACA,gBAAA;AAxDF;;AA2DA;EACE,0BAAA;EACA,mBAAA;EACA,uBAAA;EACA,wBAAA;EACA,yBAAA;EACA,2BAAA;EACA,4BAAA;EACA,2BAAA;EACA,2BAAA;EACA,2BAAA;EACA,8BAAA;AAxDF;;AA2DA;;;;EAIE,6BAAA;EACA,mBAAA;EACA,sBAAA;EACA,uBAAA;EACA,oBAAA;EACA,yBAAA;EACA,YAAA;AAxDF;;AA2DA;;;;;;;;;;;;EAYE,mBAAA;EACA,sBAAA;EACA,uBAAA;AAxDF;;AA2DA;EACE,kBAAA;EACA,mDAAA;EACA,qDAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,SAAA;EACA,mBAAA;EACA,8BAAA;EACA,gCAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,YAAA;EACA,yCAAA;EACA,8EAAA;EACA,wCAAA;EACA,UAAA;EACA,kBAAA;EACA,oBAAA;AAxDF;;AA2DA;EACE,8BAAA;AAxDF;;AA2DA;EACE,sBAAA;AAxDF;;AA2DA;EACE,2CAAA;EACA,mBAAA;AAxDF;;AA2DA;EACE,WAAA;EACA,YAAA;EACA,cAAA;AAxDF;;AA2DA;EACE,kCAAA;AAxDF;;AA2DA;EACE,UAAA;EACA,mBAAA;EACA,oBAAA;AAxDF;;AA2DA,uBAAA;AACA;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,2BAAA;EACA,MAAA;EACA,OAAA;AAxDF;;AA2DA,YAAA;AACA;EACE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,eAAA;EACA,WAAA;AAxDF;;AA2DA;EACE;IACE,UAAA;IACA,iDAAA;EAxDF;EA2DA;IACE,UAAA;IACA,2CAAA;EAzDF;EA4DA;IACE,UAAA;IACA,2CAAA;EA1DF;EA6DA;IACE,UAAA;IACA,iDAAA;EA3DF;AACF;AA8DA;EACE;IAEE,kFACE;EA9DJ;EAkEA;IACE,kFACE;EAjEJ;AACF;AAqEA;EACE;IAEE,mBAAA;IACA,YAAA;EApEF;EAuEA;IACE,sBAAA;IACA,UAAA;EArEF;AACF;AAwEA;EACE;IAEE,UAAA;EAvEF;EA0EA;IACE,UAAA;EAxEF;AACF;AA2EA;EACE;IACE,UAAA;EAzEF;EA4EA;IAEE,aAAA;EA3EF;EA8EA;IACE,UAAA;EA5EF;AACF;AA+EA;EACE,kBAAA;EACA,OAAA;EACA,yBAAA;EACA,UAAA;EACA,oBAAA;EACA,mBAAA;EACA,SAAA;EACA,4BAAA;EACA,mCAAA;EACA,gBAAA;EACA,iBAAA;EACA,sBAAA;EACA,yBAAA;EACA,mBAAA;EACA,oBAAA;EACA,kBAAA;EACA,iGAAA;EAMA,0CAAA;EACA,mBAAA;EACA,gFACE;EAEF,UAAA;EACA,iDAAA;EACA,+BAAA;EACA,wHAAA;EACA,gBAAA;AApFF;;AAuFA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,iBAAA;AApFF;;AAuFA;EACE,cAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,oBAAA;EAEA,mCAAA;EAEA,sBAAA;EAEA,qBAAA;EAEA,kBAAA;EACA,mGACE;EAEF,yCAAA;AAtFF;;AAyFA;EACE,kBAAA;EACA,oBAAA;EACA,mBAAA;EACA,gBAAA;AAtFF;;AAyFA;EACE,WAAA;EACA,kBAAA;EACA,OAAA;EACA,UAAA;EACA,QAAA;EACA,UAAA;EACA,oBAAA;EACA,qCAAA;EACA,8CAAA;EACA,UAAA;EACA,8DAAA;AAtFF;;AAyFA;EACE,UAAA;AAtFF;;AAyFA;EACE,kBAAA;EACA,qBAAA;EACA,cAAA;EACA,iFACE;EAEF,0DAAA;AAxFF;;AA2FA;EACE,kBAAA;EACA,UAAA;EACA,cAAA;EACA,iFACE;AAzFJ;;AA6FA;EACE,kBAAA;EACA,UAAA;EACA,cAAA;AA1FF;;AA6FA;EACE;IACE,8FAAA;IACA,eAAA;EA1FF;EA6FA;;;;IAIE,eAAA;EA3FF;EA8FA;;IAEE,eAAA;IACA,aAAA;EA5FF;AACF;AA+FA;EACE,kBAAA;EACA,WAAA;EACA,eAAA;AA7FF;;AAgGA;EACE,cAAA;AA7FF;;AAgGA;EACE,aAAA;AA7FF;;AAgGA;EACE;IACE,aAAA;EA7FF;AACF;AA+FA;EACE;IACE,cAAA;IACA,kBAAA;IACA,uCAAA;IACA,OAAA;IACA,QAAA;IACA,WAAA;IACA,0KAAA;IASA,eAAA;EArGF;EAwGA;IACE,YAAA;IACA,iBAAA;IACA,eAAA;IACA,MAAA;EAtGF;AACF;AAwGA;EACE;IACE,iBAAA;EAtGF;AACF;AAyGA;EACE;IACE,aAAA;EAvGF;EA0GA;IACE,cAAA;IACA,kBAAA;IACA,WAAA;IACA,OAAA;IACA,QAAA;IACA,WAAA;IACA,eAAA;IACA,WAAA;EAxGF;EA2GA;IACE,cAAA;EAzGF;EA4GA;IACE,YAAA;IACA,gBAAA;IACA,aAAA;IACA,MAAA;EA1GF;EA6GA;IACE,cAAA;IACA,YAAA;EA3GF;EA8GA;IACE,wBAAA;IACA,eAAA;IACA,QAAA;IACA,gBAAA;IACA,uBAAA;IACA,iBAAA;IACA,kBAAA;EA5GF;EA+GA;IACE,WAAA;IACA,YAAA;EA7GF;EAgHA;IACE,WAAA;IACA,YAAA;EA9GF;AACF;AAiHA;EACE,wCAAA;EACA,iBAAA;EACA,gBAAA;EACA,gBAAA;EACA,SAAA;EACA,cAAA;EACA,cAAA;EACA,WAAA;EACA,eAAA;EACA,UAAA;EACA,gBAAA;EACA,SAAA;EACA,gBAAA;EACA,qBAAA;EACA,2CAAA;AA/GF;;AAkHA;EACE,eAAA;EACA,+BAAA;EACA,gDAAA;EACA,8BAAA;EACA,0BAAA;EACA,oGAAA;AA/GF;;AAkHA;EACE,eAAA;EACA,kDAAA;AA/GF;AAiHE;EACE,cAAA;EACA,2CAAA;AA/GJ;AAiHI;EACE,cAAA;EACA,8BAAA;EACA,gCAAA;AA/GN;AAmHE;EACE,2CAAA;AAjHJ;;AAqHA;EACE,eAAA;AAlHF;AAoHE;EAEE,cAAA;EACA,2CAAA;AAnHJ;AAsHE;EACE,cAAA;EACA,gDAAA;EACA,8BAAA;AApHJ;;AAwHA;EACE,4BAAA;AArHF;AAuHE;EACE,yBAAA;AArHJ;AAuHI;EACE,cAAA;EACA,8BAAA;EACA,gCAAA;AArHN;;AA0HA;EACE,yBAAA;EACA,cAAA;EACA,wCAAA;EACA,YAAA;EACA,kBAAA;EACA,YAAA;EACA,eAAA;EACA,kBAAA;EACA,eAAA;EACA,qBAAA;AAvHF;;AA0HA,yFAAA;AACA;EACE;IACE,mDAAA;IACA,wCAAA;EAvHF;AACF;AA0HA;EACE;IACE,0BAAA;IACA,kBAAA;IACA,uBAAA;EAxHF;AACF;AA2HA;EACE,8BAAA;EACA,mDAAA;EACA,mEAAA;EACA,kBAAA;EACA,yDAAA;EACA,UAAA;EACA,gBAAA;EACA,kBAAA;AAzHF;;AA4HA;EACE,WAAA;EACA,kBAAA;EACA,OAAA;EACA,QAAA;EACA,MAAA;EACA,iCAAA;EACA,sJAAA;EAQA,oBAAA;EACA,WAAA;AAhIF;;AAmIA;EACE,aAAA;AAhIF;;AAmIA;EACE,gCAAA;AAhIF;;AAmIA;EACE,kBAAA;EACA,8BAAA;AAhIF;;AAmIA;EACE,4BAAA;EACA,mBAAA;AAhIF;;AAmIA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,gCAAA;EACA,qBAAA;EACA,yBAAA;EACA,eAAA;EACA,gBAAA;EACA,6CAAA;EACA,2CAAA;AAhIF;;AAmIA;;EAEE,WAAA;EACA,SAAA;EACA,WAAA;EACA,uFAAA;AAhIF;;AAmIA;EACE,uFAAA;AAhIF;;AAmIA;EACE;IACE,aAAA;EAhIF;AACF;AAmIA;EACE;IACE,gBAAA;EAjIF;AACF;AAoIA;EACE;IACE,8DAAA;EAlIF;AACF;AAqIA;EACE,yBAAA;AAnIF;;AAsIA;EACA;IACE,eAAA;EAnIA;AACF;AAqIA,gCAAA;AACA;EACE;IACE,UAAA;EAnIF;AACF;AAuIA,WAAA;AACA;EACE;IACE,UAAA;EArIF;EAwIA;IACE,iCAAA;EAtIF;EAyIA;IACE,oDAAA;IACA,qDAAA;EAvIF;AACF;AA0IA;EACE,iBAAA;AAxIF;AAyIE;EAFF;IAGI,gBAAA;EAtIF;AACF;AAwIE;EAEE,iBAAA;AAvIJ;AAwII;EAHF;IAII,gBAAA;EArIJ;AACF;;AAyIA,+BAAA;AACA;EACE,YAAA;EACA,8BAAA;EACA,0BAAA,EAAA,wDAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;AAtIF;;AAwIA;EACE;IACE,kBAAA;EArIF;AACF;AAuIA;EACE;IACE,iBAAA;EArIF;AACF;AAuIA;EACE,SAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;AArIF;;AAwIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EAEA;+DAAA;AArIF;AAuIE;EACE,6BAAA;EACA,mBAAA;EACA,4BAAA;EACA,sBAAA;EACA,uBAAA;EACA,2BAAA;AArIJ;AAwIE;;;EAGE,6BAAA;EACA,mBAAA;EACA,sBAAA;EACA,uBAAA;EACA,uBAAA;AAtIJ;;AA0IA;;EAEE,WAAA;EACA,YAAA;EACA,YAAA;EACA,mBAAA;AAvIF;;AA0IA;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,gBAAA;AAvIF;;AA2IA;EACE,kBAAA;EACA,QAAA;EACA,WAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,SAAA;AAxIF;AA0IE;EACE,WAAA;EACA,YAAA;EACA,2CAAA;EACA,yBAAA;EACA,kBAAA;EACA,0CAAA;AAxIJ;AA2IE;EACE,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,gCAAA;EACA,yBAAA;AAzIJ;AA4IE;EACE,aAAA;EACA,QAAA;AA1IJ;AA4II;EACE,UAAA;EACA,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,oDAAA;AA1IN;AA4IM;EAAiB,qBAAA;AAzIvB;AA0IM;EAAiB,qBAAA;AAvIvB;;AA4IA;EACE;IAAK,yBAAA;EAxIL;AACF;AA0IA;EACE;IAAgB,oBAAA;IAAwB,YAAA;EAtIxC;EAuIA;IAAiB,sBAAA;IAAwB,UAAA;EAnIzC;AACF;AAqIA;EACE,kBAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,kBAAA;EACA,6DAAA;EACA,WAAA;EACA,oBAAA,EAAA,+CAAA;AAnIF;AAqIE;EACE,oBAAA,EAAA,+BAAA;AAnIJ;;AAuIA;EACE,uBAAA;AApIF;AAsIE;EAHF;IAII,0BAAA;EAnIF;AACF;;AAsIA,sBAAA;AAEA,0DAAA;AAEE;EACE,uBAAA;AArIJ;AAwIE;EACE,uBAAA;EACA,gCAAA;AAtIJ;;AAyIA;EACE,gBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,WAAA;AAtIF;;AAyIA,uBAAA;AACA;EACE,wBAAA;EACA,WAAA;EACA,+BAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,+EAAA;AAtIF;;AA6IA;EACE,WAAA;EACA,SAAA;EACA,gBAAA;EACA,UAAA;EACA,mBAAA;EACA,+EAAA;EAKA,uEAAA;AA9IF;AAgJE;EACE,WAAA;EACA,UAAA;EACA,mDAAA;AA9IJ;;AAkJA,0BAAA;AACA;EACE,aAAA;EACA,mBAAA;EACA,+CAAA;EACA,WAAA;EACA,iBAAA;EACA,SAAA,EAAA,4BAAA;EACA,YAAA,EAAA,mBAAA;EACA,QAAA;AA/IF;;AAkJA;;EAEE,cAAA;EACA,YAAA;AA/IF;;AAkJA;EACE,2BAAA;AA/IF;;AAkJA,kFAAA;AACA;EACE,oBAAA;EACA,gBAAA;EACA,mCAAA;EACA,mBAAA;EACA,8BAAA;EACA,UAAA;EACA,YAAA;AA/IF;;AAkJA;EACE,iBAAA;EACA,YAAA;EACA,cAAA;AA/IF;;AAkJA;;EAEE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AA/IF;;AAkJA;EACE,oBAAA;AA/IF;;AAkJA;EACE,mBAAA;EACA,YAAA;EACA,cAAA;AA/IF;;AAkJA;EACE,yBAAA;AA/IF;;AAkJA;EACE;IACE,iBAAA;EA/IF;AACF;AAkJA,sCAAA;AACA;EACE,SAAA,EAAA,6BAAA;AAhJF;;AAmJA;EACE;IACE,SAAA;EAhJF;AACF;AAmJA;EACE;IACE,SAAA;EAjJF;EAoJA;IACE,QAAA;EAlJF;AACF;AAqJA;EACE;IACE,SAAA;EAnJF;EAsJA;IACE,QAAA;EApJF;EAuJA;IACE,eAAA;EArJF;AACF;AAwJA,uBAAA;AACA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AAtJF;;AAyJA,sBAAA;AACA;EACE,gCAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;AAtJF;;AAyJA;EACE;IACE,eAAA;EAtJF;AACF;AAyJA;EACE;IACE,eAAA;IACA,sBAAA;EAvJF;AACF;AA0JA;EACE,+BAAA;AAxJF;;AA4JA;EACE,oBAAA;EACA,mBAAA;EACA,YAAA;EACA,kBAAA;AAzJF;;AA4JA;EACE,aAAA;EACA,WAAA;EACA,YAAA;EACA,8BAAA;EACA,mBAAA;AAzJF;;AA4JA;EACE,oBAAA;EACA,mBAAA;EACA,YAAA;EACA,cAAA;EACA,YAAA;AAzJF;;AA4JA;EACE,cAAA;AAzJF;;AA4JA;EACE,cAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;AAzJF;;AA4JA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,cAAA;AAzJF;;AA4JA;EACE,cAAA;AAzJF;;AA4JA;EACE,cAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,4CAAA;EACA,gDAAA;AAzJF;;AA4JA;EACE;IAEE,UAAA;EA1JF;EA4JA;IACE,aAAA;EA1JF;AACF;AA6JA;EACE,kBAAA;AA3JF;;AA8JA;EACE,kBAAA;EACA,SAAA;EACA,OAAA;EACA,gBAAA;EACA,uCAAA;EAEA,2BAAA;EACA,mBAAA;EACA,UAAA;EACA,UAAA;EACA,oBAAA;EACA,2BAAA;EACA,sBAAA;EACA,gFACE;EAEF,cAAA;EACA,2CAAA;EACA,yCAAA;EACA,2BAAA;EACA,kBAAA;EACA,wBAAA;AA7JF;;AAgKA;EACE,gBAAA;EACA,gBAAA;AA7JF;;AAgKA;;EAEE,eAAA;AA7JF;;AA+JA;EACE;;IAEE,eAAA;EA5JF;AACF;AA8JA;EACE;;IAEE,eAAA;EA5JF;AACF;AA8JA;;;EAGE,cAAA;EACA,YAAA;AA5JF;;AA8JA;;;EAGE,cAAA;EACA,UAAA;AA3JF;;AAgKA;EACE,eAAA;AA7JF;;AAgKA;EACE;IACE,UAAA;IACA,2BAAA;EA7JF;EA+JA;IACE,UAAA;IACA,wBAAA;EA7JF;AACF;AAgKA,sCAAA;AACA;EACE,UAAA;EACA,QAAA;AA9JF;;AAiKA;EACE,UAAA;EACA,oBAAA;EACA,wBAAA;AA9JF;;AAiKA,uBAAA;AACA;EACE,kBAAA;AA9JF;;AAiKA,oEAAA;AACA;EACE,qBAAA;EACA,+BAAA;EACA,wBAAA;AA9JF;;AAgKA;EACE,wBAAA;AA7JF;;AAgKA;EACE,uBAAA;EACA,uBAAA;EACA,gDAAA;EACA,iBAAA;EACA,gBAAA;EACA,kCAAA;AA7JF;;AAgKA;EACE,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,oBAAA;EACA,aAAA;AA7JF;;AAgKA;EACE,cAAA;EACA,kBAAA;EACA,gCAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;EACA,iBAAA;EACA,qBAAA;EACA,iDAAA;EACA,eAAA;EACA,gBAAA,EAAA,6BAAA;AA7JF;;AAgKA;EACE;IACE,eAAA;IACA,kBAAA;EA7JF;AACF;AAgKA;EACE,mBAAA;AA9JF;;AAiKA;EACE,qCAAA;EACA,WAAA;AA9JF;;AAiKA;uEAAA;AAEA;EACE,2CAAA;AA9JF;;AAgKA;EACE,sBAAA;AA7JF;;AAgKA,kEAAA;AACA;EACE,yBAAA;EACA,oCAAA;AA7JF;;AA+JA;EACE,yBAAA;EACA,oCAAA;AA5JF;;AA+JA;EACE,+BAAA;EACA,gDAAA;EACA,8BAAA;EACA,0BAAA;EACA,oGAAA;AA5JF;;AA8JA;EACE;IACE,0BAAA;EA3JF;AACF;AA8JA,8BAAA;AACA;EACE,aAAA;EACA,eAAA;EACA,gBAAA;EACA,YAAA;EACA,WAAA;EACA,eAAA;AA5JF;;AA+JA;EACE,wBAAA;EACA;IACE,eAAA;IACA,iBAAA;IACA,UAAA;IACA,gBAAA;IACA,yBAAA;IACA,kBAAA;IACA,4BAAA;IACA,wDAAA;IACA,YAAA;IACA,gBAAA;IACA,iCAAA;IACA,0CAAA;EA5JF;EA+JA;IACE,wBAAA;EA7JF;EAgKA,6BAAA;EACA;IACE,kBAAA;IACA,UAAA;IACA,SAAA;IACA,eAAA;IACA,WAAA;IACA,YAAA;IACA,gBAAA;EA9JF;EAiKA,sBAAA;EACA;IACE,eAAA;IACA,gBAAA;IACA,sBAAA;IACA,eAAA;IACA,kDAAA;EA/JF;EAkKA,yBAAA;EACA;IACE,kBAAA;IACA,mBAAA;IACA,aAAA;IACA,sDACE;IAEF,eAAA;IACA,gBAAA;IACA,sBAAA;EAlKF;EAqKA;IACE,qCAAA;EAnKF;EAsKA,6BAAA;EACA;IACE,iBAAA;IACA,kBAAA;IACA,gDAAA;IACA,+BAAA;EApKF;EAuKA;IACE,eAAA;IACA,aAAA;EArKF;EAwKA,wCAAA;EACD,4BAAA;EACD;IACE,eAAA;IACA,YAAA;IACA,gBAAA;IACA,gCAAA;EAtKA;EAyKF;IACE,yBAAA;EAvKA;EAyKA;IACE,kBAAA;EAvKF;EA0KA,yCAAA;EACA;IACE,kBAAA;IACA,SAAA;IACA,UAAA;IACA,eAAA;IACA,WAAA;IACA,eAAA;IACA,iBAAA;IACA,uBAAA;IACA,gBAAA;IACA,cAAA;IACA,YAAA;IACA,eAAA;IACA,kBAAA;IACA,UAAA;IACA,oBAAA;IACA,0CAAA;IACA,2BAAA;IACA,sCAAA;IACA,0BAAA;EAxKF;EA0KA,sBAAA;EACA;IACE,+BAAA;IACA,eAAA;EAxKF;EA2KA;IACE,wBAAA;EAzKF;EA4KA,wBAAA;EACA;IACE,eAAA;IACA,QAAA;IACA,+BAAA;IACA,gCAAA,EAAA,iCAAA;IACA,2BAAA;IACA,YAAA;EA1KF;EA6KA,wCAAA;EACA;IACE,8BAAA;EA3KF;EA8KF;IACE;MAAO,UAAA;MAAY,2BAAA;IA1KjB;IA2KF;MAAK,UAAA;MAAY,wBAAA;IAvKf;EACF;EAyKA,2BAAA;EACA;IACE;MACE,UAAA;MACA,2BAAA;IAvKF;IAyKA;MACE,UAAA;MACA,wBAAA;IAvKF;EACF;EA0KA;IACE;MACE,UAAA;IAxKF;IA0KA;MACE,UAAA;IAxKF;EACF;EA2KA;IACE;MACE,UAAA;MACA,wCAAA;IAzKF;IA2KA;MACE,UAAA;MACA,kCAAA;IAzKF;EACF;AACF;AA4KA,gDAAA;AACA;EACE;;IAEE,wBAAA;EA1KF;AACF;AA6KA,2BAAA;AACA;EACE;IACE,aAAA;EA3KF;EA8KA;IACE,aAAA;EA5KF;EA8KA;IACE,2BAAA;EA5KF;EA+KA;IACE,kBAAA;IACA,QAAA;IACA,SAAA;IACA,gCAAA;IACA,oBAAA;IACA,kBAAA;IACA,YAAA;IACA,4BAAA;EA7KF;EAgLA;IACE,YAAA;IACA,WAAA;IACA,mCAAA;IACA,kBAAA;EA9KF;EAiLA;IACE,OAAA;EA/KF;EAkLA;IACE,kBAAA;IACA,aAAA;IACA,wBAAA;IACA,mBAAA;IACA,yBAAA;IACA,eAAA;EAhLF;EAmLA;IACE,oBAAA;IACA,kBAAA;IACA,UAAA;IACA,mBAAA;IACA,UAAA;IACA,QAAA;IACA,mBAAA;IACA,sBAAA;IACA,eAAA;IACA,WAAA;IACA,SAAA;IACA,UAAA;IACA,eAAA;IACA,cAAA;EAjLF;AACF;AAqLA;EACE,gBAAA;AAnLF;;AAsLA;;EAEE,qBAAA;EACA,6BAAA;EACA,+BAAA;AAnLF;;AAsLA;EACE;IACE,kCAAA;IACA,gBAAA;IACA,aAAA;IACA,sBAAA;IACA,0BAAA;IACA,2BAAA;EAnLF;EAsLA;IACE,wBAAA;IACA,yBAAA;IACA,4BAAA;EApLF;EAuLA;IACE,gBAAA;IACA,MAAA;IACA,WAAA;IACA,cAAA;EArLF;EAwLA;IACE,2BAAA;IACA,oBAAA;EAtLF;EAyLA;IACE,cAAA;IACA,aAAA;IACA,gBAAA;IACA,kBAAA;IACA,iCAAA;IACA,4BAAA;EAvLF;EA0LA;IACE,kBAAA;IACA,YAAA;IACA,kBAAA;IACA,oBAAA;IACA,gBAAA;EAxLF;EA2LA;IACE,oBAAA;EAzLF;EA2LA;IACE,YAAA;IACA,kBAAA;EAzLF;EA4LA;IACE,iBAAA;IACA,4BAAA;EA1LF;EA6LA;IACE,4BAAA;EA3LF;EA8LA;IACE,kCAAA;EA5LF;EA+LA;IACE,wBAAA;EA7LF;EAgMA;IACE,yBAAA;IACA,6BAAA;IACA,sBAAA;IACA,kBAAA;IACA,mBAAA;IACA,sBAAA;IACA,0BAAA;IACA,0KAAA;IASA,sBAAA;IACA,oBAAA;IACA,0BAAA;IACA,4BAAA;EAtMF;EAyMA;IACE,aAAA;IACA,iBAAA;IACA,+BAAA;EAvMF;EA0MA;IACE,cAAA;IACA,WAAA;IACA,gBAAA;IACA,MAAA;IACA,UAAA;IACA,wBAAA;EAxMF;EA2MA;IACE,2BAAA;EAzMF;EA4MA;IACE,yBAAA;IACA,gBAAA;EA1MF;EA6MA;IACE,wCAAA;IACA,0BAAA;IACA,4BAAA;IACA,2BAAA;IACA,kBAAA;IACA,kBAAA;EA3MF;EA8MA;IACE,4BAAA;EA5MF;EA8MA;IACE,iBAAA;EA5MF;EA+MA;IACE,kBAAA;IACA,eAAA;EA7MF;EAgNA;IACE,kBAAA;IACA,QAAA;IACA,aAAA;IACA,mBAAA;IACA,uBAAA;IACA,+BAAA;IACA,WAAA;IACA,oBAAA;EA9MF;EAiNA;IACE,WAAA;IACA,YAAA;IACA,kBAAA;IACA,+BAAA;IACA,2CAAA;IACA,aAAA;IACA,mBAAA;IACA,uBAAA;IACA,cAAA;IACA,yCAAA;IACA,2DAAA;IACA,wCAAA;EA/MF;EAiNE;IACE,WAAA;IACA,YAAA;IACA,gBAAA;IACA,sBAAA;EA/MJ;EAkNE;IACE,sBAAA;IACA,oCAAA;EAhNJ;AACF;AAoNA;EACE,qBAAA;EACA,uBAAA;EACA,uBAAA;EACA,6BAAA;EACA,gCAAA;EACA,iCAAA;EACA,iDAAA;AAlNF;;AAqNA,uBAAA;AACA;EACE;IACE,2BAAA;IACA,uBAAA;EAlNF;AACF;AAoNA;EACE,kBAAA;EACA,YAAA;EACA,UAAA;EACA,WAAA;EACA,kCAAA;EACA,iFAAA;EAMA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,iBAAA;EACA,2EACE;AAxNJ;;AA6NA;EACE,2BAAA;EACA,UAAA;EACA,kBAAA;EACA,oBAAA;AA1NF;;AA6NA;EACE,UAAA;AA1NF;;AA6NA;EACE,uDAAA;AA1NF;;AA6NA;EACE,4BAAA;AA1NF;;AA6NA;EACE,4BAAA;AA1NF;;AA6NA;EACE,YAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;EACA,2BAAA;EACA,kDAAA;EACA,gBAAA;EACA,uCAAA;EACA,kCAAA;EACA,2CAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,qHACE;EAGF,oBAAA;EACA,yDAAA;EACA,qDAAA;AA7NF;;AA+NA;EACE;IACE,UAAA;EA5NF;AACF;AA+NA;EACE,UAAA;EACA,kBAAA;EACA,eAAA;AA7NF;;AAgOA;EACE,WAAA;EACA,kBAAA;EACA,OAAA;EACA,QAAA;EACA,YAAA;EACA,oCAAA;EACA,oBAAA;EACA,iHAAA;AA7NF;;AAqOA,uFAAA;AACA;EACE;IACE,qFAAA;EAlOF;EAyOA;IACE,iHAAA;EAvOF;AACF;AA+OA;EACE;IAEE,aAAA;EA9OF;EAgPA;IACE,UAAA;EA9OF;AACF;AAiPA,wBAAA;AACA;EACE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,aAAA;EACA,yBAAA;EACA,eAAA;AA/OF;;AAkPA;EACE,aAAA;EACA,SAAA;AA/OF;;AAkPA;EACE;IACE,kBAAA;IACA,oBAAA;IACA,mBAAA;IACA,SAAA;IACA,iBAAA;IACA,kBAAA;EA/OF;EAkPA;IACE,WAAA;IACA,kBAAA;IACA,QAAA;IACA,sBAAA;IACA,kCAAA;IAEA,0BAAA;IACA,8EACE;IAEF,WAAA;IACA,oBAAA;EAlPF;EAqPA;IACE,kBAAA;IACA,UAAA;EAnPF;AACF;AAsPA;EACE;IACE,eAAA;EApPF;AACF;AAuPA;EACE;IACE,eAAA;EArPF;AACF;AAwPA,gBAAA;AACA;EACE,WAAA;EACA,eAAA;EACA,qBAAA;EACA,gBAAA;EACA,mBAAA;AAtPF;;AAwPA;EACE;IACE,eAAA;EArPF;AACF;AAwPA;EACE,cAAA;EACA,0BAAA;AAtPF;;AAyPA,kEAAA;AACA;EACE,cAAA;EACA,WAAA;EACA,YAAA;EACA,wBAAA;EACA,0CAAA;EACA,cAAA;AAtPF;;AAyPA;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,wCAAA;AAtPF;AAwPE;EACE,WAAA;EACA,YAAA;EACA,kDAAA;AAtPJ;;AA0PA;EACE;IACE,WAAA;IACA,YAAA;EAvPF;AACF;AA2PA,gFAAA;AACA;EACE,oBAAA;EACA,sBAAA;EACA,mBAAA;EACA,QAAA;EACA,oBAAA;EACA,eAAA;AAzPF;;AA4PA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,qCAAA;EACA,2CAAA;EACA,oBAAA;EACA,yBAAA;EACA,eAAA;EACA,iEAAA;EACA,cAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAAA;AAzPF;;AA4PA;EACE,oCAAA;EACA,qCAAA;EACA,cAAA;EACA,sBAAA;AAzPF;;AA4PA;EACE,kCAAA;EACA,qCAAA;EACA,cAAA;AAzPF;;AA4PA;EACE,kCAAA;EACA,oCAAA;EACA,cAAA;AAzPF;;AA4PA;EACE,gBAAA;AAzPF;;AA4PA;EACE,oCAAA;EACA,sCAAA;EACA,cAAA;AAzPF;;AA4PA;EACE,kBAAA;EACA,cAAA;AAzPF;;AA4PA;EACE,kBAAA;EACA,gBAAA;EACA,eAAA;AAzPF;;AA6PA,wCAAA;AACA;EACE,aAAA;EACA,0CAAA;EACA,kBAAA;EACA,gBAAA;EACA,WAAA;EACA,sBAAA;EACA,yCAAA;EACA,kBAAA;EACA,kBAAA;AA1PF;;AA6PA;EACE,sBAAA;EACA,YAAA;EACA,cAAA;EACA,WAAA;EACA,oBAAA;AA1PF;;AA6PA;EACE,cAAA;EACA,WAAA;EACA,iBAAA;EACA,iBAAA;EACA,cAAA;EACA,cAAA;EACA,aAAA;EACA,MAAA;AA1PF;;AA6PA;EACE;IACE,cAAA;IACA,kBAAA;IACA,gBAAA;EA1PF;EA6PA;IACE,WAAA;IACA,cAAA;IACA,WAAA;EA3PF;EA8PA;IACE,cAAA;IACA,sBAAA;EA5PF;EA+PA;IACE,YAAA;IACA,gBAAA;EA7PF;AACF;AAgQA;EACE,0BAAA;EACA,0BAAA;AA9PF;;AAiQA;EACE;IAAK,aAAA;IAAe,qDAAA;IAAoD,mBAAA;EA3PxE;EA4PA;IAAM,UAAA;IAAY,gEAAA;IAAkE,sBAAA;IAAwB,WAAA;EAtP5G;EAuPA;IAAO,aAAA;IAAe,qDAAA;IAAoD,mBAAA;EAlP1E;AACF;AAoPA;EACE,gDAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,wBAAA;EACA,gBAAA;EACA,UAAA;EACA,SAAA;EACA,uBAAA;EACA,aAAA;EACA,eAAA;EACA,wBAAA;EACA,kBAAA;EACA,QAAA;AAlPF;;AAoPA;EACE;IACE,gBAAA;EAjPF;EAmPA;IACE,WAAA;IACA,kBAAA;IACA,YAAA;IACA,eAAA;IACA,gBAAA;EAjPF;AACF;AAoPA;EACE,WAAA;EACA,YAAA;EACA,UAAA;EACA,oBAAA;EACA,iBAAA;EACA,sBAAA;AAlPF;;AAqPA;EACE,eAAA;EACA,gBAAA;EACA,gBAAA;AAlPF;;AAqPA;EACE,2CAAA;EACA,mBAAA;EACA,kBAAA;AAlPF;;AAqPA;EACE;IACE,WAAA;IACA,YAAA;EAlPF;EAqPA;IACE,eAAA;EAnPF;AACF;AAuPA;EACE,eAAA;EACA,QAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,iCAAA;EACA,0BAAA;AArPF;;AAwPA;EACE,kBAAA;EACA,2CAAA;EACA,mBAAA;EACA,mBAAA;EACA,cAAA;EACA,8CAAA;AArPF;;AAwPA,iFAAA;AACA;EACE,eAAA;EACA,QAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,iCAAA;EACA,0BAAA;AArPF;;AAuPA;EACE,uBAAA;EACA,aAAA;EACA,2CAAA;EACA,mBAAA;EACA,mBAAA;EACA,cAAA;EACA,wCAAA;EACA,2CAAA;AApPF;;AAsPA;EACE,gBAAA;EACA,cAAA;EACA,oDAAA;EACA,eAAA;AAnPF;;AAqPA;EACE,gBAAA;EACA,+BAAA;EACA,gBAAA;AAlPF;;AAoPA;EACE,2CAAA;EACA,kBAAA;EACA,iBAAA;EACA,mCAAA;EACA,WAAA;EACA,eAAA;AAjPF","sourcesContent":["@use \"./styles/variables\" as *;\nbody {\n  background-color: $accent-color !important;\n  color: #fff;\n  font-family: \"Orbitron\", sans-serif !important;\n  overflow-x: hidden;\n  /* 🔥 horizontal scroll permanently band */\n}\n\n/* ===== GLOBAL SCROLLBAR ===== */\n\n::-webkit-scrollbar-thumb {\n  background: #4b3f5e;\n  /* scrollbar color */\n  border-radius: 10px;\n}\n\n::-webkit-scrollbar-thumb:hover {\n  background: #4b3f5e;\n}\n\n/* Firefox */\n* {\n  scrollbar-width: thin;\n  scrollbar-color: #4b3f5e #fff;\n}\n\nh1 {\n  font-size: 2rem;\n  color: #e50914;\n  margin-bottom: 1rem;\n}\n\n.App {\n  text-align: center;\n}\n\n.App-logo {\n  height: 40vmin;\n  pointer-events: none;\n}\n\n@media (prefers-reduced-motion: no-preference) {\n  .App-logo {\n    animation: App-logo-spin infinite 20s linear;\n  }\n}\n\n.App-header {\n  background-color: #282c34;\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  font-size: calc(10px + 2vmin);\n  color: white;\n}\n\n.App-link {\n  color: #61dafb;\n}\n\n@keyframes App-logo-spin {\n  from {\n    transform: rotate(0deg);\n  }\n\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.form-select {\n  background-color: #333;\n  color: #fff;\n  border: none;\n}\n\n.card {\n  background-color: #181818;\n  border: none;\n  transition: transform 0.3s ease;\n}\n\n.card:hover {\n  transform: scale(1.03);\n  z-index: 2;\n}\n\n.card-title,\n.card-subtitle {\n  color: #fff;\n}\n\n.card-link {\n  color: #e50914;\n  text-decoration: none;\n}\n\n.card-link:hover {\n  text-decoration: underline;\n}\n\n.nav-tabs .nav-link {\n  background-color: transparent;\n  color: #999;\n  border: none;\n  border-bottom: 2px solid transparent;\n}\n\n.nav-tabs .nav-link.active {\n  color: #fff;\n  border-bottom: 2px solid #e50914;\n}\n\n.spinner-border {\n  width: 3rem;\n  height: 3rem;\n}\n\n.alert-info {\n  background-color: #333;\n  color: #fff;\n  border-color: #e50914;\n}\n\n.video-row {\n  --vip-row-gutter: 5px;\n  --vip-row-arrow-gap: 0px;\n  position: relative;\n  padding: 0 var(--vip-row-gutter);\n}\n\n.vip-row-slider {\n  --vip-row-gutter: 40px;\n  --vip-row-arrow-gap: 6px;\n  position: relative;\n  padding: 0 var(--vip-row-gutter);\n}\n\n.video-card {\n  min-width: 300px;\n  max-width: 300px;\n  flex: 0 0 auto;\n}\n\n/* Carousel navigation: exact 135° hollow chevrons with sharp geometry.\n   The button remains a large full-height hit target; only the SVG is visible. */\n.scroll-arrow {\n  position: absolute;\n  top: 50% !important;\n  transform: translateY(-50%);\n  z-index: 10;\n  display: flex !important;\n  align-items: center;\n  justify-content: center;\n  width: max(40px, calc(var(--vip-row-gutter, 40px) - var(--vip-row-arrow-gap, 6px))) !important;\n  height: 100% !important;\n  min-height: 200px;\n  padding: 0;\n  border: none;\n  color: rgba(255, 255, 255, 0.74) !important;\n  font-size: 0 !important;\n  line-height: 0 !important;\n  cursor: pointer;\n  outline: none;\n  -webkit-appearance: none;\n  appearance: none;\n  -webkit-tap-highlight-color: transparent;\n}\n\n.scroll-arrow::before,\n.scroll-arrow::after {\n  content: none !important;\n  display: none !important;\n}\n\n.scroll-arrow.left {\n  left: 0 !important;\n  background: linear-gradient(to right, rgba(0, 0, 0, 0.32), rgba(0, 0, 0, 0)) !important;\n}\n\n.scroll-arrow.right {\n  right: 0 !important;\n  background: linear-gradient(to left, rgba(0, 0, 0, 0.32), rgba(0, 0, 0, 0)) !important;\n}\n\n.scroll-arrow__shape {\n  display: block;\n  width: auto;\n  height: clamp(42px, 26%, 56px);\n  overflow: visible;\n  opacity: 1;\n  filter: drop-shadow(0 2px 5px rgba(0, 0, 0, 0.5));\n  transition: transform 0.16s ease, color 0.16s ease, opacity 0.16s ease;\n  pointer-events: none;\n}\n\n.scroll-arrow:hover {\n  color: #fff !important;\n}\n\n.scroll-arrow:hover .scroll-arrow__shape {\n  transform: scale(1.035);\n}\n\n.scroll-arrow:focus-visible {\n  outline: 2px solid rgba(167, 139, 250, 0.9);\n  outline-offset: -2px;\n}\n\n.scroll-arrow.slick-disabled {\n  cursor: default;\n  color: rgba(255, 255, 255, 0.34) !important;\n}\n\n@media (max-width: 768px) {\n  .video-row {\n    --vip-row-gutter: 28px;\n    --vip-row-arrow-gap: 4px;\n    --mobile-scroll-arrow-edge-offset: 0px;\n  }\n\n  .vip-row-slider {\n    --vip-row-gutter: 0px;\n    --vip-row-arrow-gap: 0px;\n    padding: 0;\n  }\n\n  .scroll-arrow {\n    width: 48px !important;\n    min-height: 120px;\n    color: rgba(255, 255, 255, 0.8) !important;\n  }\n\n  .scroll-arrow.left {\n    left: calc(var(--mobile-scroll-arrow-edge-offset, 0px) * -1) !important;\n    background: linear-gradient(to right, rgba(0, 0, 0, 0.30), rgba(0, 0, 0, 0)) !important;\n  }\n\n  .scroll-arrow.right {\n    right: calc(var(--mobile-scroll-arrow-edge-offset, 0px) * -1) !important;\n    background: linear-gradient(to left, rgba(0, 0, 0, 0.30), rgba(0, 0, 0, 0)) !important;\n  }\n\n  .scroll-arrow__shape {\n    height: clamp(34px, 32%, 46px);\n  }\n\n  .video-card {\n    min-width: 240px;\n    max-width: 240px;\n  }\n}\n\n.scroll-container {\n  overflow-x: auto;\n  overflow-y: hidden;\n}\n\n/* Use native scrollbars; no WebKit overrides */\n\n.video-card {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  /* pushes button to bottom */\n  height: 100%;\n  /* make all cards equal height */\n  padding: 1rem;\n  background-color: #1e1e2f;\n  border-radius: 8px;\n}\n\n.video-info {\n  flex: 1 1 auto;\n  margin-bottom: 1rem;\n  /* space before button */\n}\n\n.video-button {\n  align-self: flex-start;\n  /* or center if you prefer */\n}\n\n/* Remove custom override of overflow utility to preserve defaults */\n\n/* Removed custom .fancy-scroll styles to restore native browser scrollbars */\n\n.netflix-tabs .tab-content {\n  padding-left: 0;\n  padding-right: 0;\n}\n\n.trending-scroll {\n  padding-right: 2rem;\n  padding-left: 2rem;\n}\n\n// new css\n\n.width_100 {\n  width: 100% !important;\n}\n\n// new css\n\n.country-select-box {\n  margin-top: 2px !important;\n}\n\n/* NAVBAR  header */\n// .ds-navbar {\n//   background: linear-gradient(to right, #2d1e4e, #604191);\n//   min-height: 70px;\n// }\n\n/* LOGO — primary header brand, links to default home */\n.ds-logo-link {\n  flex-shrink: 0;\n  display: inline-flex;\n  align-items: center;\n  text-decoration: none;\n  z-index: 2;\n  cursor: pointer;\n\n  &:hover,\n  &:focus-visible {\n    opacity: 0.92;\n  }\n}\n\n.ds-logo-img {\n  height: var(--ds-navbar-height, 70px);\n  width: auto;\n  object-fit: contain;\n  display: block;\n}\n\n@media (min-width: 1001px) {\n  .ds-logo-img {\n    height: 99px;\n    padding-top: 11px;\n  }\n}\n\n/* LINKS */\n.ds-link {\n  color: rgba(255, 255, 255, 0.87);\n  // font-weight: 500;\n  cursor: pointer;\n  position: relative;\n  padding: 6px 8px;\n  transition: 0.2s;\n  text-transform: uppercase;\n}\n\n.ds-link:hover {\n  color: rgba(255, 255, 255, 0.9);\n}\n\n/* ACTIVE TAB */\n.ds-active {\n  color: rgba(255, 255, 255, 0.9);\n  // font-weight: 600;\n}\n\n// .ds-active::after {\n//   content: \"\";\n//   position: absolute;\n//   bottom: -5px;\n//   left: 0;\n//   width: 100%;\n//   height: 3px;\n//   background: #ff4b5c;\n//   border-radius: 2px;\n// }\n\n.ds-menu-wrap {\n  margin-top: 15px !important;\n}\n\n/* RESPONSIVE */\n@media (max-width: 768px) {\n  .ds-menu-wrap {\n    gap: 8px !important;\n  }\n\n  .ds-country-select {\n    max-width: 120px;\n    font-size: 13px;\n  }\n}\n\n/* Premium TV loader page styling */\n.premium-loader-container {\n  /* The initial headlines request owns the viewport; navigation is revealed\n     with the loaded content so the header cannot flash ahead of the data. */\n  position: relative;\n  width: 100%;\n  min-height: 100dvh;\n  background: radial-gradient(circle at center, #181528 0%, #0a0a0f 100%);\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  z-index: 2;\n}\n\n.premium-loader-img {\n  width: min(340px, 80vw);\n  height: auto;\n  margin-bottom: 0;\n}\n\n.loading-text {\n  font-family: \"Orbitron\", sans-serif;\n  font-size: clamp(2.1rem, 3.5vw, 2.7rem);\n  font-weight: 900;\n  letter-spacing: 4px;\n  color: #c084fc;\n  margin-top: 35px;\n  text-transform: uppercase;\n  animation: loadingGlowPulse 2.6s ease-in-out infinite;\n  text-align: center;\n  line-height: 1.4;\n\n  @media (max-width: 768px) {\n    font-size: clamp(1.4rem, 5vw, 2rem);\n    letter-spacing: 2px;\n  }\n}\n\n.loading-text-line {\n  display: block;\n  opacity: 0;\n  transform: translateY(10px);\n  animation: loadingLineReveal 0.42s ease-out forwards;\n}\n\n.loading-text-line--1 { animation-delay: 0.3s; }\n.loading-text-line--2 { animation-delay: 0.8s; }\n.loading-text-line--3 { animation-delay: 1.2s; }\n\n@keyframes loadingGlowPulse {\n  0%, 100% {\n    text-shadow:\n      0 0 4px rgba(197, 140, 255, 0.18),\n      0 0 10px rgba(197, 140, 255, 0.12);\n  }\n  50% {\n    text-shadow:\n      0 0 8px rgba(197, 140, 255, 0.42),\n      0 0 20px rgba(197, 140, 255, 0.26),\n      0 0 34px rgba(197, 140, 255, 0.14);\n  }\n}\n\n@keyframes loadingLineReveal {\n  from {\n    opacity: 0;\n    transform: translateY(10px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .loading-text {\n    animation: none;\n    text-shadow:\n      0 0 4px rgba(197, 140, 255, 0.18),\n      0 0 10px rgba(197, 140, 255, 0.12);\n  }\n}\n\n/* Round spinning loader */\n.spinner {\n  width: 60px;\n  height: 60px;\n  border: 6px solid rgba(255, 255, 255, 0.2);\n  border-top: 6px solid #ffffff;\n  border-radius: 50%;\n  animation: spin 0.9s linear infinite;\n}\n\n/* Animation */\n@keyframes spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n\n/* WRAPPER */\n\n.vip-hero-play-btn:hover {\n  background-color: #4b3f5e;\n}\n\n/* unique wrapper for each video */\n.ytRowItemUnique {\n  padding: 10px;\n}\n\n/* card look */\n.ytRowItemUnique > div {\n  border-radius: 16px;\n  overflow: hidden;\n  background: #121212;\n  transition:\n    transform 0.25s ease,\n    box-shadow 0.25s ease;\n}\n\n.ytRowItemUnique > div:hover {\n  transform: scale(1.03);\n  box-shadow: 0 12px 28px rgba(0, 0, 0, 0.45);\n}\n\n/* remove center gap when few videos */\n.slick-track {\n  margin-left: 0 !important;\n}\n\n/* arrows styling */\n.slick-prev,\n.slick-next {\n  z-index: 3;\n}\n\n.slick-prev:before,\n.slick-next:before {\n  content: none !important;\n  display: none !important;\n}\n\n/* ===== MOBILE VIEW ===== */\n@media (max-width: 548px) {\n  .responsive_header {\n    flex-direction: column;\n  }\n}\n\n.vip-divider {\n  position: relative;\n  /* Keep the divider in the normal document flow (use absolute if parent is relative for overlay) */\n  left: 0 !important;\n  /* Force the divider to start from the very left edge */\n  width: 100vw !important;\n  /* Set width to full viewport width */\n  height: 0.5px !important;\n  /* Hair-thin line */\n  background: #e6d7ff !important;\n  /* Divider color */\n  border-radius: 0 !important;\n  /* Make the line straight */\n  opacity: 0.9 !important;\n  /* Slight transparency */\n  // margin: 5px 0 !important;            /* Vertical spacing (top & bottom) */\n  margin-left: calc(-50vw + 50%) !important;\n  // margin-bottom: 5px;\n  margin-top: -17px;\n  margin-bottom: 10px;\n}\n\n.news-block__title {\n  display: block;\n  width: 100%;\n  box-sizing: border-box;\n  margin: 0;\n  color: #f4f4f6;\n  font-family: \"Space Grotesk\", sans-serif;\n  font-size: 15px !important;\n  font-weight: 500;\n  line-height: 1.2;\n  padding-top: 0px;\n  padding-bottom: 3px;\n  padding-left: 5px;\n  // background: linear-gradient(to bottom,\n  //     rgba(0, 0, 0, 0.25),\n  //     rgba(0, 0, 0, 0.35));\n\n  // backdrop-filter: blur(14px);\n  // -webkit-backdrop-filter: blur(14px);\n}\n@media (max-width: 768px) {\n  .news-block__title {\n    padding-left: 0px;\n    padding-bottom: 0px;\n  }\n}\n\n.vip-hero {\n  --vip-full-bleed-overscan: 4px;\n  position: static;\n  width: calc(100vw + var(--vip-full-bleed-overscan));\n  margin-left: calc(-50vw + 50% - (var(--vip-full-bleed-overscan) / 2));\n  height: 100vh;\n  overflow: hidden;\n  display: flex;\n  align-items: center;\n}\n\n\n.vip-hero-player-inner {\n  position: relative;\n  width: 100%;\n  padding-bottom: 56.25%;\n  background: #000;\n  border-radius: 12px;\n  overflow: hidden;\n}\n\n.vip-hero-player-inner:fullscreen,\n.vip-hero-player-inner:-webkit-full-screen {\n  width: 100vw !important;\n  height: 100vh !important;\n  padding-bottom: 0 !important;\n  border-radius: 0 !important;\n  background: #000;\n}\n\n.vip-hero-player-inner.is-pseudo-fullscreen {\n  position: fixed !important;\n  inset: 0 !important;\n  width: 100vw !important;\n  height: 100vh !important;\n  height: 100dvh !important;\n  max-height: none !important;\n  padding-bottom: 0 !important;\n  border-radius: 0 !important;\n  background: #000 !important;\n  overflow: hidden !important;\n  z-index: 2147483000 !important;\n}\n\n.vip-hero-player-inner iframe,\n.vip-hero-player-inner .vip-hero-player-iframe-wrapper,\n.vip-hero-player-inner .vip-hero-player-iframe-wrapper > div,\n.vip-hero-player-iframe {\n  position: absolute !important;\n  inset: 0 !important;\n  width: 100% !important;\n  height: 100% !important;\n  border: 0 !important;\n  display: block !important;\n  z-index: 100;\n}\n\n.vip-hero-player-inner:fullscreen iframe,\n.vip-hero-player-inner:fullscreen .vip-hero-player-iframe-wrapper,\n.vip-hero-player-inner:fullscreen .vip-hero-player-iframe-wrapper > div,\n.vip-hero-player-inner:fullscreen .vip-hero-player-iframe,\n.vip-hero-player-inner:-webkit-full-screen iframe,\n.vip-hero-player-inner:-webkit-full-screen .vip-hero-player-iframe-wrapper,\n.vip-hero-player-inner:-webkit-full-screen .vip-hero-player-iframe-wrapper > div,\n.vip-hero-player-inner.is-pseudo-fullscreen iframe,\n.vip-hero-player-inner.is-pseudo-fullscreen .vip-hero-player-iframe-wrapper,\n.vip-hero-player-inner.is-pseudo-fullscreen .vip-hero-player-iframe-wrapper > div,\n.vip-hero-player-inner.is-pseudo-fullscreen .vip-hero-player-iframe,\n.vip-hero-player-inner:-webkit-full-screen .vip-hero-player-iframe {\n  inset: 0 !important;\n  width: 100% !important;\n  height: 100% !important;\n}\n\n.vip-hero-fullscreen-btn {\n  position: absolute;\n  right: calc(env(safe-area-inset-right, 0px) + 12px);\n  bottom: calc(env(safe-area-inset-bottom, 0px) + 86px);\n  width: 34px;\n  height: 34px;\n  padding: 0;\n  border: 0;\n  border-radius: 18px;\n  background: rgba(0, 0, 0, 0.3);\n  color: rgba(255, 255, 255, 0.96);\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  z-index: 140;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.35);\n  transition: background-color 0.2s ease, transform 0.2s ease, opacity 0.2s ease;\n  -webkit-tap-highlight-color: transparent;\n  opacity: 0;\n  visibility: hidden;\n  pointer-events: none;\n}\n\n.vip-hero-fullscreen-btn:hover {\n  background: rgba(0, 0, 0, 0.4);\n}\n\n.vip-hero-fullscreen-btn:active {\n  transform: scale(0.96);\n}\n\n.vip-hero-fullscreen-btn:focus-visible {\n  outline: 2px solid rgba(255, 255, 255, 0.9);\n  outline-offset: 2px;\n}\n\n.vip-hero-fullscreen-btn svg {\n  width: 18px;\n  height: 18px;\n  display: block;\n}\n\n.vip-hero-fullscreen-btn.is-active {\n  background: rgba(18, 18, 18, 0.72);\n}\n\n.vip-hero-fullscreen-btn.is-visible {\n  opacity: 1;\n  visibility: visible;\n  pointer-events: auto;\n}\n\n/* Dynamic Background */\n.vip-hero-bg {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  object-position: center top;\n  top: 0;\n  left: 0;\n}\n\n/* Content */\n.vip-hero-content {\n  position: relative;\n  z-index: 2;\n  width: 100%;\n  max-width: none;\n  color: #fff;\n}\n\n@keyframes vip-hero-ai-hint-lifecycle {\n  0% {\n    opacity: 0;\n    transform: translate3d(-10px, 8px, 0) scale(0.94);\n  }\n\n  13.64% {\n    opacity: 1;\n    transform: translate3d(0, -1px, 0) scale(1);\n  }\n\n  90.91% {\n    opacity: 1;\n    transform: translate3d(0, -1px, 0) scale(1);\n  }\n\n  100% {\n    opacity: 0;\n    transform: translate3d(14px, -10px, 0) scale(0.9);\n  }\n}\n\n@keyframes vip-hero-ai-hint-glow {\n  0%,\n  100% {\n    text-shadow:\n      0 0 10px rgba(139, 92, 246, 0.28),\n      0 0 18px rgba(167, 139, 250, 0.16);\n  }\n\n  50% {\n    text-shadow:\n      0 0 14px rgba(139, 92, 246, 0.52),\n      0 0 28px rgba(196, 181, 253, 0.36);\n  }\n}\n\n@keyframes aiHintPulse {\n  0%,\n  100% {\n    transform: scale(1);\n    opacity: 0.9;\n  }\n\n  50% {\n    transform: scale(1.08);\n    opacity: 1;\n  }\n}\n\n@keyframes vip-hero-ai-hint-caret {\n  0%,\n  100% {\n    opacity: 0;\n  }\n\n  50% {\n    opacity: 1;\n  }\n}\n\n@keyframes vip-hero-ai-hint-fade-only {\n  0% {\n    opacity: 0;\n  }\n\n  13.64%,\n  90.91% {\n    opacity: 0.96;\n  }\n\n  100% {\n    opacity: 0;\n  }\n}\n\n.vip-hero-ai-hint {\n  position: absolute;\n  left: 0;\n  bottom: calc(100% + 10px);\n  z-index: 3;\n  display: inline-flex;\n  align-items: center;\n  gap: 12px;\n  max-width: min(98vw, 1200px);\n  font-size: clamp(12px, 1.2vw, 20px);\n  font-weight: 600;\n  line-height: 1.05;\n  letter-spacing: 0.03em;\n  text-transform: uppercase;\n  white-space: nowrap;\n  pointer-events: none;\n  padding: 10px 14px;\n  background: linear-gradient(\n    to top,\n    rgba(0, 0, 0, 0.9),\n    rgba(0, 0, 0, 0.71),\n    rgba(0, 0, 0, 0.45)\n  );\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  border-radius: 14px;\n  box-shadow:\n    0 10px 28px rgba(0, 0, 0, 0.28),\n    0 0 0 1px rgba(167, 139, 250, 0.08);\n  opacity: 0;\n  transform: translate3d(-10px, 8px, 0) scale(0.94);\n  will-change: opacity, transform;\n  animation: vip-hero-ai-hint-lifecycle var(--homepage-ai-hint-total-ms, 300000ms) cubic-bezier(0.22, 1, 0.36, 1) forwards;\n  overflow: hidden;\n}\n\n.vip-hero-ai-hint__pointer {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex: 0 0 auto;\n  width: 30px;\n  height: 30px;\n  line-height: 0;\n  margin-right: 8px;\n}\n\n.ai-tap-icon {\n  display: block;\n  width: 30px;\n  height: 30px;\n  background-color: #8b5cf6;\n  vertical-align: -2px;\n  -webkit-mask-image: var(--ai-tap-icon-mask);\n  mask-image: var(--ai-tap-icon-mask);\n  -webkit-mask-repeat: no-repeat;\n  mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  mask-position: center;\n  -webkit-mask-size: contain;\n  mask-size: contain;\n  filter:\n    drop-shadow(0 0 3px rgba(139, 92, 246, 0.75))\n    drop-shadow(0 0 8px rgba(139, 92, 246, 0.35));\n  animation: aiHintPulse 2.2s ease infinite;\n}\n\n.vip-hero-ai-hint__label {\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n  overflow: hidden;\n}\n\n.vip-hero-ai-hint__label::after {\n  content: \"\";\n  position: absolute;\n  top: 8%;\n  bottom: 8%;\n  right: 0;\n  width: 2px;\n  border-radius: 999px;\n  background: rgba(255, 255, 255, 0.95);\n  box-shadow: 0 0 12px rgba(255, 255, 255, 0.45);\n  opacity: 0;\n  animation: vip-hero-ai-hint-caret 0.85s steps(1, end) infinite;\n}\n\n.vip-hero-ai-hint__label[data-empty=\"false\"]::after {\n  opacity: 1;\n}\n\n.vip-hero-ai-hint__label-text {\n  position: relative;\n  display: inline-block;\n  color: #ffffff;\n  text-shadow:\n    0 0 16px rgba(255, 255, 255, 0.12),\n    0 0 24px rgba(139, 92, 246, 0.1);\n  animation: vip-hero-ai-hint-glow 2.8s ease-in-out infinite;\n}\n\n.vip-hero-ai-hint__label-accent {\n  position: relative;\n  z-index: 1;\n  color: #8b5cf6;\n  text-shadow:\n    0 0 10px rgba(139, 92, 246, 0.55),\n    0 0 18px rgba(139, 92, 246, 0.22);\n}\n\n.vip-hero-ai-hint__label-rest {\n  position: relative;\n  z-index: 1;\n  color: #ffffff;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .vip-hero-ai-hint {\n    animation: vip-hero-ai-hint-fade-only var(--homepage-ai-hint-total-ms, 300000ms) ease forwards;\n    transform: none;\n  }\n\n  .vip-hero-ai-hint__pointer,\n  .vip-hero-ai-hint__label,\n  .vip-hero-ai-hint__label-text,\n  .ai-tap-icon {\n    animation: none;\n  }\n\n  .vip-hero-ai-hint__label::after,\n  .vip-hero-ai-hint__label-text::after {\n    animation: none;\n    display: none;\n  }\n}\n\n.vip-hero-content--mobile {\n  position: relative;\n  width: 100%;\n  padding: 0 40px;\n}\n\n.vip-hero-title__comment {\n  flex-shrink: 0;\n}\n\n.vip-hero-content--desktop {\n  display: none;\n}\n\n@media (min-width: 801px) {\n  .vip-hero-content--mobile {\n    display: none;\n  }\n}\n@media (min-width: 801px) {\n  .vip-hero-content--desktop {\n    display: block;\n    position: absolute;\n    top: var(--vip-hero-desktop-top, -85px);\n    left: 0;\n    right: 0;\n    width: 100%;\n    background: linear-gradient(\n    to top,\n    #000000 0%,\n    rgba(0, 0, 0, 0.95) 15%,\n    rgba(0, 0, 0, 0.75) 35%,\n    rgba(0, 0, 0, 0.45) 60%,\n    rgba(0, 0, 0, 0.15) 80%,\n    rgba(0, 0, 0, 0) 100%\n    );\n    padding: 0 50px;\n  }\n\n  .vip-hero-title__comment--desktop {\n    float: right;\n    margin-left: 10px;\n    margin-top: 2px;\n    top: 0;\n  }\n}\n@media (min-width: 1401px) {\n  .vip-hero-content--desktop {\n    padding: 5px 52px;\n  }\n}\n\n@media (max-width: 800px) {\n  .vip-hero-content--desktop {\n    display: none;\n  }\n\n  .vip-hero-content--mobile {\n    display: block;\n    position: absolute;\n    bottom: 8px;\n    left: 0;\n    right: 0;\n    width: 100%;\n    padding: 0 12px;\n    z-index: 15;\n  }\n\n  .vip-hero-title {\n    display: block;\n  }\n\n  .vip-hero-title__comment {\n    float: right;\n    margin-left: 8px;\n    margin-top: 0;\n    top: 0;\n  }\n\n  .vip-hero-title__text {\n    display: block;\n    min-width: 0;\n  }\n\n  .vip-hero-ai-hint {\n    bottom: calc(100% + 8px);\n    max-width: min(98vw, 100vw);\n    gap: 8px;\n    font-size: 9.5px;\n    letter-spacing: 0.015em;\n    padding: 8px 10px;\n    border-radius: 8px;\n  }\n\n  .vip-hero-ai-hint__pointer {\n    width: 18px;\n    height: 18px;\n  }\n\n  .ai-tap-icon {\n    width: 18px;\n    height: 18px;\n  }\n}\n\n.vip-hero-title {\n  font-family: \"Space Grotesk\", sans-serif;\n  font-size: 37.5px;\n  font-weight: 500;\n  line-height: 1.1;\n  margin: 0;\n  color: #f8f8f8;\n  display: block;\n  width: 100%;\n  max-width: 100%;\n  padding: 0;\n  background: none;\n  border: 0;\n  border-radius: 0;\n  text-decoration: none;\n  text-shadow: 0 4px 18px rgba(0, 0, 0, 0.85);\n}\n\n.vip-hero-title__text {\n  display: inline;\n  text-decoration-line: underline;\n  text-decoration-color: rgba(248, 248, 248, 0.65);\n  text-decoration-thickness: 1px;\n  text-underline-offset: 2px;\n  transition: color 0.15s ease, text-decoration-color 0.15s ease, text-decoration-thickness 0.15s ease;\n}\n\n.vip-hero-title--clickable {\n  cursor: pointer;\n  transition: color 0.2s ease, text-shadow 0.2s ease;\n\n  &:hover {\n    color: #ffffff;\n    text-shadow: 0 6px 22px rgba(0, 0, 0, 0.95);\n\n    .vip-hero-title__text {\n      color: #ffffff;\n      text-decoration-color: #c084fc;\n      text-decoration-thickness: 1.5px;\n    }\n  }\n\n  &:active {\n    text-shadow: 0 4px 18px rgba(0, 0, 0, 0.85);\n  }\n}\n\n.vip-hero-title--disabled {\n  cursor: default;\n\n  &:hover,\n  &:active {\n    color: inherit;\n    text-shadow: 0 4px 18px rgba(0, 0, 0, 0.85);\n  }\n\n  .vip-hero-title__text {\n    color: inherit;\n    text-decoration-color: rgba(248, 248, 248, 0.65);\n    text-decoration-thickness: 1px;\n  }\n}\n\n.news-block__title--clickable {\n  transition: color 0.15s ease;\n\n  &:hover {\n    color: #c084fc !important;\n\n    u {\n      color: #c084fc;\n      text-decoration-color: #c084fc;\n      text-decoration-thickness: 1.5px;\n    }\n  }\n}\n\n.vip-hero-play-btn {\n  background-color: #4b3f5e;\n  display: block;\n  margin-left: var(--vip-row-gutter, 40px);\n  border: none;\n  padding: 12px 28px;\n  color: white;\n  font-size: 16px;\n  border-radius: 6px;\n  cursor: pointer;\n  transition: 0.3s ease;\n}\n\n/* Desktop headline baseline stays fixed; AdaptiveHeadline can still shrink when needed */\n@media (min-width: 769px) {\n  .news-block__title {\n    width: calc(100% - (2 * var(--vip-row-gutter, 40px)));\n    margin-left: var(--vip-row-gutter, 40px);\n  }\n}\n\n@media (min-width: 801px) {\n  .news-block__title {\n    font-size: 32px !important;\n    margin-bottom: 0px;\n    letter-spacing: -0.02em;\n  }\n}\n\n.vip-after-hero {\n  --vip-full-bleed-overscan: 8px;\n  width: calc(100vw + var(--vip-full-bleed-overscan));\n  margin-left: calc(-50vw + 50% - (var(--vip-full-bleed-overscan) / 2));\n  position: relative;\n  margin-top: calc(var(--vip-after-hero-overlap, 0px) * -1);\n  z-index: 5;\n  background: none;\n  isolation: isolate;\n}\n\n.vip-after-hero::before {\n  content: \"\";\n  position: absolute;\n  left: 0;\n  right: 0;\n  top: 0;\n  height: clamp(180px, 28vw, 420px);\n  background: linear-gradient(\n    to top,\n    rgba(0, 0, 0, 1) 0%,\n    rgba(0, 0, 0, 0.82) 28%,\n    rgba(0, 0, 0, 0.48) 58%,\n    rgba(0, 0, 0, 0.18) 80%,\n    rgba(0, 0, 0, 0) 100%\n  );\n  pointer-events: none;\n  z-index: -1;\n}\n\n.vip-after-hero-top-gap {\n  display: none;\n}\n\n.slider-container.slider-row {\n  transition: background 0.3s ease;\n}\n\n.vip-more-rows {\n  display: flow-root;\n  background: rgba(0, 0, 0, 0.50);\n}\n\n.slider-container.slider-row.first-row {\n  padding-top: 20px !important;\n  margin-bottom: 10px;\n}\n\n.vip-more-headlines-indicator {\n  display: none;\n  align-items: center;\n  gap: 14px;\n  color: rgba(255, 255, 255, 0.95);\n  letter-spacing: 0.1em;\n  text-transform: uppercase;\n  font-size: 14px;\n  font-weight: 700;\n  margin: 10px var(--vip-row-gutter, 40px) 20px;\n  text-shadow: 0 1px 10px rgba(0, 0, 0, 0.55);\n}\n\n.vip-more-headlines-indicator::before,\n.vip-more-headlines-indicator::after {\n  content: \"\";\n  flex: 1;\n  height: 2px;\n  background: linear-gradient(90deg, rgba(255, 255, 255, 0.18), rgba(255, 255, 255, 0.6));\n}\n\n.vip-more-headlines-indicator::after {\n  background: linear-gradient(90deg, rgba(255, 255, 255, 0.6), rgba(255, 255, 255, 0.18));\n}\n\n@media (min-width: 801px) {\n  .vip-more-headlines-indicator {\n    display: flex;\n  }\n}\n\n@media (max-width: 1200px) {\n  .slider-container.slider-row.first-row {\n    margin-bottom: 0;\n  }\n}\n\n@media (min-width: 801px) {\n  .slider-container.slider-row.first-row {\n    padding-top: var(--vip-first-row-top-padding, 84px) !important;\n  }\n}\n\n.slider-container.slider-row:not(.first-row) {\n  padding-top: 0 !important;\n}\n\n@media (min-width: 768px) {\n.vip-more-rows > .slider-container.slider-row + .slider-container.slider-row {\n  margin-top: 4px;\n}\n}\n/* Screens smaller than 1400px */\n@media (max-width: 1400px) {\n  .vip-after-hero {\n    padding: 0;\n  }\n\n}\n\n/* Mobile */\n@media (max-width: 800px) {\n  .vip-after-hero {\n    padding: 0;\n  }\n\n  .vip-after-hero::before {\n    height: clamp(140px, 44vw, 260px);\n  }\n\n  .slider-container.slider-row {\n    padding-left: var(--vip-row-gutter, 10px) !important;\n    padding-right: var(--vip-row-gutter, 10px) !important;\n  }\n}\n\n.new_livess {\n  margin-top: 100px;\n  @media (max-width: 800px) {\n    margin-top: 60px;\n  }\n\n  &.has-player {\n    // Keep margin consistent to avoid jump\n    margin-top: 100px;\n    @media (max-width: 800px) {\n      margin-top: 60px;\n    }\n  }\n}\n\n/* ===== LIVE TV PLAYER ===== */\n.live-player-container {\n  width: 100vw;\n  margin-left: calc(-50vw + 50%);\n  height: calc(100vh - 86px); /* Fills space between header and footer approximately */\n  background: #000;\n  position: relative;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n}\n@media (min-width: 801px) {\n  .live-player-container {\n    margin-top: -100px; \n  }\n}\n@media (max-width: 800px) {\n  .live-player-container {\n    margin-top: -60px;\n  }\n}\n.live-player-wrapper {\n  flex: 1;\n  width: 100%;\n  height: 100%;\n  position: relative;\n  background: #000;\n}\n\n.live-player-inner {\n  width: 100%;\n  height: 100%;\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  /* SmartYouTubeEmbed uses a padding-bottom aspect-ratio trick;\n     override it here so it fills the full live-player height */\n  > div {\n    position: absolute !important;\n    inset: 0 !important;\n    padding-bottom: 0 !important;\n    width: 100% !important;\n    height: 100% !important;\n    border-radius: 0 !important;\n  }\n\n  .yt-fill,\n  .yt-iframe,\n  iframe {\n    position: absolute !important;\n    inset: 0 !important;\n    width: 100% !important;\n    height: 100% !important;\n    border: none !important;\n  }\n}\n\n.live-player-iframe,\n.live-player-video {\n  width: 100%;\n  height: 100%;\n  border: none;\n  object-fit: contain;\n}\n\n.live-player-error {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #fff;\n  background: #111;\n}\n\n// ── Stream loading overlay ────────────────────────────────────────────────────\n.live-stream-loader {\n  position: absolute;\n  inset: 0;\n  z-index: 20;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  background: #0a0a0f;\n  gap: 18px;\n\n  &__spinner {\n    width: 52px;\n    height: 52px;\n    border: 4px solid rgba(255, 255, 255, 0.12);\n    border-top-color: #e63946;\n    border-radius: 50%;\n    animation: live-spin 0.85s linear infinite;\n  }\n\n  &__label {\n    font-size: 13px;\n    font-weight: 500;\n    letter-spacing: 0.06em;\n    color: rgba(255, 255, 255, 0.55);\n    text-transform: uppercase;\n  }\n\n  &__dot-row {\n    display: flex;\n    gap: 6px;\n\n    span {\n      width: 6px;\n      height: 6px;\n      border-radius: 50%;\n      background: #e63946;\n      animation: live-dot-bounce 1.2s ease-in-out infinite;\n\n      &:nth-child(2) { animation-delay: 0.2s; }\n      &:nth-child(3) { animation-delay: 0.4s; }\n    }\n  }\n}\n\n@keyframes live-spin {\n  to { transform: rotate(360deg); }\n}\n\n@keyframes live-dot-bounce {\n  0%, 80%, 100% { transform: scaleY(1);   opacity: 0.4; }\n  40%            { transform: scaleY(1.6); opacity: 1;   }\n}\n\n.live-player-info {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  padding: 15px 25px;\n  background: linear-gradient(transparent, rgba(0, 0, 0, 0.85));\n  z-index: 10;\n  pointer-events: none; /* Let clicks pass through to video if needed */\n\n  button {\n    pointer-events: auto; /* Re-enable for close button */\n  }\n}\n\n.slider-container {\n  padding: 0px !important;\n\n  @media (max-width: 768px) {\n    padding: 0 25px !important;\n  }\n}\n\n/* ===== RESET ===== */\n\n/* ======= STICKY HEADER (navbar + breathing room) ===== */\n.ds-header-sticky--overlay {\n  .ds-navbar {\n    background: transparent;\n  }\n\n  .ds-header-subfooter {\n    background: transparent;\n    border-bottom-color: transparent;\n  }\n}\n.ds-header-sticky {\n  position: sticky;\n  top: 0;\n  left: 0;\n  width: 100%;\n  z-index: 50;\n}\n\n/* ===== NAVBAR ===== */\n.ds-navbar {\n  --ds-navbar-height: 65px;\n  width: 100%;\n  height: var(--ds-navbar-height);\n  padding: 0px 22px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  background: linear-gradient(\n    to bottom,\n    rgba(0, 0, 0, 0.90),\n    rgba(0, 0, 0, 0.71)\n  );\n}\n\n.ds-header-subfooter {\n  width: 100%;\n  height: 0;\n  overflow: hidden;\n  opacity: 0;\n  border-bottom: none;\n  background: linear-gradient(\n    to bottom,\n    rgba(0, 0, 0, 0.62),\n    rgba(0, 0, 0, 0.40)\n  );\n  transition: height 0.2s ease, opacity 0.2s ease, border-color 0.2s ease;\n\n  &.ds-header-subfooter--visible {\n    height: 8px;\n    opacity: 1;\n    border-bottom: 1px solid rgba(255, 255, 255, 0.045);\n  }\n}\n\n/* ===== MENU WRAP ===== */\n.ds-menu-wrap {\n  display: grid;\n  align-items: center;\n  grid-template-columns: auto minmax(0, 1fr) auto;\n  width: 100%;\n  margin-left: 30px;\n  flex: 1; /* allow it to grow/shrink */\n  min-width: 0; /* avoid overflow */\n  gap: 8px;\n}\n\n.ds-menu-primary,\n.ds-menu-secondary {\n  flex: 0 0 auto;\n  min-width: 0;\n}\n\n.ds-menu-primary {\n  justify-content: flex-start;\n}\n\n/* Event Country | Live | Global Country — equal side columns keep Live centered */\n.ds-menu-mid-trio {\n  display: inline-flex;\n  margin: 0px 15px;\n  grid-template-columns: 1fr auto 1fr;\n  align-items: center;\n  justify-content: space-between;\n  width: 96%;\n  min-width: 0;\n}\n\n.ds-menu-mid-trio__event {\n  justify-self: end;\n  min-width: 0;\n  max-width: 34%;\n}\n\n.ds-menu-mid-trio__event > .ds-link,\n.ds-menu-mid-trio__country > .ds-link {\n  display: block;\n  max-width: 100%;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.ds-menu-mid-trio__live {\n  justify-self: center;\n}\n\n.ds-menu-mid-trio__country {\n  justify-self: start;\n  min-width: 0;\n  max-width: 34%;\n}\n\n.ds-menu-secondary {\n  justify-content: flex-end;\n}\n\n@media (max-width: 1400px) {\n  .ds-menu-wrap {\n    margin-left: 15px;\n  }\n}\n\n/* responsive gap classes for header */\n.ds-header-gap {\n  gap: 24px; /* default gap-4 equivalent */\n}\n\n@media (max-width: 1400px) {\n  .ds-header-gap {\n    gap: 16px;\n  }\n}\n\n@media (max-width: 1200px) {\n  .ds-header-gap {\n    gap: 12px;\n  }\n\n  .ds-menu-wrap {\n    gap: 4px;\n  }\n}\n\n@media (max-width: 1320px) {\n  .ds-header-gap {\n    gap: 10px;\n  }\n\n  .ds-menu-wrap {\n    gap: 3px;\n  }\n\n  .ds-live-dropdown-toggle {\n    min-width: auto;\n  }\n}\n\n/* LEFT + RIGHT GROUP */\n.ds-group {\n  display: flex;\n  align-items: center;\n  gap: 28px;\n}\n\n/* ===== LINKS ===== */\n.ds-link {\n  color: rgba(255, 255, 255, 0.87);\n  font-size: 18px;\n  font-weight: 750;\n  letter-spacing: 0.05em;\n  text-transform: uppercase;\n  cursor: pointer;\n  transition: 0.25s;\n  white-space: nowrap;\n}\n\n@media (max-width: 1400px) {\n  .ds-link {\n    font-size: 16px;\n  }\n}\n\n@media (max-width: 1200px) {\n  .ds-link {\n    font-size: 14px;\n    letter-spacing: 0.03em;\n  }\n}\n\n.ds-link:hover {\n  color: rgba(255, 255, 255, 0.9);\n}\n\n//* DROPDOWN STYLES */\n.ds-live-dropdown-toggle {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.28rem;\n  min-width: 4.75rem;\n}\n\n.ds-live-dropdown-toggle--full {\n  display: flex;\n  width: 100%;\n  min-width: 0;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.ds-live-dropdown-toggle--full .ds-live-dropdown-toggle__label {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.28rem;\n  flex: 0 1 auto;\n  min-width: 0;\n}\n\n.ds-live-dropdown-toggle__left {\n  flex: 0 0 auto;\n}\n\n.ds-live-dropdown-toggle__right {\n  flex: 0 0 auto;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  line-height: 1;\n}\n\n.ds-live-dropdown-toggle__caret {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-size: inherit;\n  line-height: 1;\n}\n\n.ds-live-dropdown-toggle .ds-dropdown-icon {\n  margin-left: 0;\n}\n\n.ds-live-indicator {\n  display: block;\n  flex-shrink: 0;\n  width: 12px;\n  height: 12px;\n  margin-right: 3px;\n  border-radius: 50%;\n  background: #a970ff;\n  box-shadow: 0 0 8px rgba(169, 112, 255, 0.7);\n  animation: dsLivePulse 1.9s ease-in-out infinite;\n}\n\n@keyframes dsLivePulse {\n  0%,\n  100% {\n    opacity: 1;\n  }\n  50% {\n    opacity: 0.55;\n  }\n}\n\n.ds-dropdown {\n  position: relative;\n}\n\n.ds-dropdown-menu {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  min-width: 170px;\n  background-color: rgba(38, 30, 50, 0.8);\n  -webkit-backdrop-filter: blur(14px);\n  backdrop-filter: blur(14px);\n  border-radius: 14px;\n  padding: 0;\n  opacity: 0;\n  pointer-events: none;\n  transform: translateY(10px);\n  transition: 0.25s ease;\n  box-shadow:\n    0 18px 40px rgba(8, 6, 14, 0.32),\n    0 0 24px rgba(129, 108, 182, 0.08);\n  z-index: 99999;\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  max-height: calc(100vh - 92px) !important;\n  overflow-y: auto !important;\n  overflow-x: hidden;\n  scrollbar-gutter: stable;\n}\n\n.ds-headlines-dropdown > .ds-dropdown-menu {\n  min-width: 320px;\n  max-width: 420px;\n}\n\n.ds-headlines-dropdown > .ds-link,\n.ds-live-dropdown-toggle {\n  font-size: 28px;\n}\n@media (max-width: 1140px) {\n  .ds-headlines-dropdown > .ds-link,\n  .ds-live-dropdown-toggle {\n    font-size: 20px;\n  }\n}\n@media (max-width: 1060px) {\n  .ds-headlines-dropdown > .ds-link,\n  .ds-live-dropdown-toggle {\n    font-size: 16px;\n  }\n}\n.ds-menu-mid-trio__event > .ds-link,\n.ds-menu-mid-trio__country > .ds-link,\n.ds-menu-secondary .ds-link {\n  color: #D8D8E0;\n  opacity: 0.9;\n}\n.ds-menu-mid-trio__event > .ds-link:hover,\n.ds-menu-mid-trio__country > .ds-link:hover,\n.ds-menu-secondary .ds-link:hover {\n  color: #e4e4ea;\n  opacity: 1;\n}\n\n\n\n.ds-headlines-dropdown .ds-dd-item {\n  max-width: none;\n}\n\n@keyframes dsDrawerDown {\n  from {\n    opacity: 0;\n    transform: translateY(-6px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n/* Align menu to the right if needed */\n.ds-dropdown-right .ds-dropdown-menu {\n  left: auto;\n  right: 0;\n}\n\n.ds-dropdown:hover > .ds-dropdown-menu {\n  opacity: 1;\n  pointer-events: auto;\n  transform: translateY(0);\n}\n\n/* 2nd level dropdown */\n.ds-dropdown-nested {\n  position: relative;\n}\n\n/* Nested category chevron: right when closed, down when expanded. */\n.arrow {\n  display: inline-block;\n  transition: transform 0.2s ease;\n  transform-origin: center;\n}\n.arrow.open {\n  transform: rotate(90deg);\n}\n\n.ds-second-level-menu {\n  margin: 6px 0 10px 14px;\n  padding: 6px 0 6px 12px;\n  border-left: 1px solid rgba(255, 255, 255, 0.12);\n  max-height: 320px;\n  overflow-y: auto;\n  animation: dsDrawerDown 0.18s ease;\n}\n\n.ds-second-level-menu .ds-dd-item {\n  padding: 8px 12px;\n  font-size: 13px;\n  font-weight: 650;\n  letter-spacing: 0.02em;\n  text-transform: none;\n  opacity: 0.92;\n}\n\n.ds-dd-item {\n  display: block;\n  padding: 12px 18px;\n  color: rgba(255, 255, 255, 0.92);\n  font-size: 16px;\n  font-weight: 700;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  line-height: 1.35;\n  text-decoration: none;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.1);\n  cursor: pointer;\n  max-width: 450px; /* prevent ultra wide menus */\n}\n\n@media (max-width: 1400px) {\n  .ds-dd-item {\n    font-size: 14px;\n    padding: 10px 14px;\n  }\n}\n\n.ds-dd-item:last-child {\n  border-bottom: none;\n}\n\n.ds-dd-item:hover {\n  background: rgba(255, 255, 255, 0.08);\n  color: #fff;\n}\n\n/* Explicit color prevents Bootstrap's .text-muted or inherited theme colors\n   from making the first language option unreadable on the dark menu. */\n.ds-dd-item--all {\n  color: rgba(255, 255, 255, 0.76) !important;\n}\n.ds-dd-item--all:hover {\n  color: #fff !important;\n}\n\n/* Persistent feedback after a category/subcategory is selected. */\n.ds-dd-item--selected {\n  color: #c084fc !important;\n  background: rgba(124, 58, 237, 0.16);\n}\n.ds-dd-item--selected:hover {\n  color: #d8b4fe !important;\n  background: rgba(124, 58, 237, 0.22);\n}\n\n.news-block__title u {\n  text-decoration-line: underline;\n  text-decoration-color: rgba(244, 244, 246, 0.55);\n  text-decoration-thickness: 1px;\n  text-underline-offset: 4px;\n  transition: color 0.15s ease, text-decoration-color 0.15s ease, text-decoration-thickness 0.15s ease;\n}\n@media (max-width: 768px) {\n  .news-block__title u {\n    text-underline-offset: 2px;\n  }\n}\n\n/* ===== MOBILE TOGGLE ===== */\n.ds-toggle-btn {\n  display: none;\n  font-size: 26px;\n  background: none;\n  border: none;\n  color: #fff;\n  cursor: pointer;\n}\n\n@media (max-width: 1000px) {\n  /* ===== SIDEBAR ===== */\n  .ds-sidebar {\n    position: fixed;\n    inset: 0 auto 0 0;\n    width: 82%;\n    max-width: 320px;\n    background-color: #4b3f5e;\n    padding: 20px 18px;\n    transform: translateX(-100%);\n    transition: transform 0.25s cubic-bezier(0.4, 0, 0.2, 1);\n    z-index: 200;\n    overflow-y: auto;\n    -webkit-overflow-scrolling: touch;\n    box-shadow: 20px 0 40px rgba(0, 0, 0, 0.6);\n  }\n\n  .ds-sidebar.open {\n    transform: translateX(0);\n  }\n\n  /* ===== CLOSE BUTTON ===== */\n  .ds-close {\n    position: absolute;\n    left: 14px;\n    top: 12px;\n    font-size: 24px;\n    color: #fff;\n    opacity: 0.8;\n    background: none;\n  }\n\n  /* ===== LINKS ===== */\n  .ds-sidebar .ds-link {\n    font-size: 15px;\n    font-weight: 700;\n    letter-spacing: 0.03em;\n    padding: 12px 0;\n    border-bottom: 1px solid rgba(255, 255, 255, 0.08);\n  }\n\n  /* ===== DROPDOWN ===== */\n  .ds-dd-item {\n    padding: 10px 10px;\n    border-radius: 10px;\n    margin: 4px 0;\n    transition:\n      background 0.25s ease,\n      transform 0.2s ease;\n    font-size: 13px;\n    line-height: 1.3;\n    letter-spacing: 0.02em;\n  }\n\n  .ds-dd-item:active {\n    background: rgba(255, 255, 255, 0.08);\n  }\n\n  /* ===== SECOND LEVEL ===== */\n  .ds-second-level {\n    margin-left: 10px;\n    padding-left: 10px;\n    border-left: 1px solid rgba(255, 255, 255, 0.08);\n    animation: slideDown 0.35s ease;\n  }\n\n  .ds-dd-item.sub {\n    font-size: 12px;\n    opacity: 0.85;\n  }\n\n  /* ===== HEADLINES DROPDOWN ICON ===== */\n /* Dropdown arrow rotation */\n.ds-dropdown-icon {\n  font-size: 12px;\n  opacity: 0.8;\n  margin-left: 6px;\n  transition: transform 0.25s ease;\n}\n\n.ds-dropdown-icon.open {\n  transform: rotate(180deg);\n}\n  .ds-sidebar .ds-dropdown {\n    position: relative;\n  }\n\n  /* ===== HEADLINES DROPDOWN WIDTH ===== */\n  .ds-sidebar .ds-dropdown-menu {\n    position: relative;\n    top: auto;\n    left: auto;\n    transform: none;\n    width: 100%;\n    margin-top: 6px;\n    padding-left: 6px;\n    background: transparent;\n    box-shadow: none;\n    display: block;\n    min-width: 0;\n    max-width: 100%;\n    padding-right: 8px;\n    opacity: 1;\n    pointer-events: auto;\n    max-height: calc(100vh - 180px) !important;\n    overflow-y: auto !important;\n    animation: mobileDropdownIn 0.24s ease;\n    transform-origin: top left;\n  }\n  /* ===== ARROW ===== */\n  .arrow {\n    transition: transform 0.3s ease;\n    font-size: 14px;\n  }\n\n  .arrow.open {\n    transform: rotate(90deg);\n  }\n\n  /* ===== OVERLAY ===== */\n  .ds-overlay {\n    position: fixed;\n    inset: 0;\n    background: rgba(0, 0, 0, 0.55);\n    /* backdrop-filter: blur(4px); */ /* 🔥 performance hog on mobile */\n    animation: fadeIn 0.2s ease;\n    z-index: 150;\n  }\n\n  /* Optional smooth slide for menu open */\n  .ds-second-level {\n    animation: slideDown 0.3s ease;\n  }\n\n@keyframes slideDown {\n  from { opacity: 0; transform: translateY(-5px); }\n  to { opacity: 1; transform: translateY(0); }\n}\n\n  /* ===== ANIMATIONS ===== */\n  @keyframes slideDown {\n    from {\n      opacity: 0;\n      transform: translateY(-6px);\n    }\n    to {\n      opacity: 1;\n      transform: translateY(0);\n    }\n  }\n\n  @keyframes fadeIn {\n    from {\n      opacity: 0;\n    }\n    to {\n      opacity: 1;\n    }\n  }\n\n  @keyframes mobileDropdownIn {\n    from {\n      opacity: 0;\n      transform: translateY(-6px) scaleY(0.98);\n    }\n    to {\n      opacity: 1;\n      transform: translateY(0) scaleY(1);\n    }\n  }\n}\n\n/* ===== DESKTOP: SIDEBAR COMPLETELY OFF ===== */\n@media (min-width: 1001px) {\n  .ds-sidebar,\n  .ds-overlay {\n    display: none !important;\n  }\n}\n\n/* ===== RESPONSIVE ===== */\n@media (max-width: 1000px) {\n  .ds-header-subfooter {\n    display: none;\n  }\n\n  .ds-menu-wrap {\n    display: none;\n  }\n  .mobile-menu-wrap {\n    margin-top: 55px !important;\n  }\n\n  .ds-logo-link {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    justify-self: center;\n    align-self: center;\n    height: 100%;\n    max-width: calc(100% - 92px);\n  }\n\n  .ds-logo-img {\n    height: 56px;\n    width: auto;\n    max-width: min(220px, calc(100vw - 96px));\n    align-self: normal;\n  }\n\n  .ds-dropdown-menu {\n    top: 01%;\n  }\n\n  .ds-navbar {\n    position: relative;\n    display: flex;\n    --ds-navbar-height: 45px;\n    align-items: center;\n    justify-content: flex-end;\n    padding: 0 12px;\n  }\n\n  .ds-toggle-btn {\n    display: inline-flex;\n    position: relative;\n    z-index: 3;\n    align-self: stretch;\n    left: 12px;\n    top: 5px;\n    align-items: center;\n    justify-content: right;\n    min-width: 51px;\n    height: 85%;\n    margin: 0;\n    padding: 0;\n    font-size: 27px;\n    line-height: 1;\n  }\n}\n\n\nbody.mobile-hero-pseudo-fullscreen {\n  background: #000;\n}\n\nbody.mobile-hero-pseudo-fullscreen .ds-header-sticky,\nbody.mobile-hero-pseudo-fullscreen .ds-footer {\n  opacity: 0 !important;\n  visibility: hidden !important;\n  pointer-events: none !important;\n}\n\n@media screen and (max-width: 800px) {\n  .trending-scroll--vip-mobile-playing {\n    height: calc(100dvh - 56px - 20px);\n    overflow: hidden;\n    display: flex;\n    flex-direction: column;\n    padding-left: 0 !important;\n    padding-right: 0 !important;\n  }\n\n  body.mobile-hero-pseudo-fullscreen .trending-scroll--vip-mobile-playing {\n    height: 100vh !important;\n    height: 100dvh !important;\n    overflow: visible !important;\n  }\n\n  .trending-scroll--vip-mobile-playing .vip-hero {\n    position: sticky;\n    top: 0;\n    z-index: 25;\n    flex: 0 0 auto;\n  }\n\n  body.mobile-hero-pseudo-fullscreen .trending-scroll--vip-mobile-playing .vip-hero {\n    position: static !important;\n    top: auto !important;\n  }\n\n  .trending-scroll--vip-mobile-playing .vip-after-hero {\n    flex: 1 1 auto;\n    min-height: 0;\n    overflow-y: auto;\n    overflow-x: hidden;\n    -webkit-overflow-scrolling: touch;\n    overscroll-behavior: contain;\n  }\n\n  .vip-hero {\n    position: relative;\n    height: auto;\n    aspect-ratio: 16 / 9;\n    align-items: stretch;\n    overflow: hidden;\n  }\n\n  .vip-hero:not(.vip-hero--is-playing) {\n    aspect-ratio: 16 / 8.6;\n  }\n  .vip-hero.vip-hero--is-playing {\n    height: auto;\n    aspect-ratio: auto;\n  }\n\n  .vip-hero-bg {\n    object-fit: cover;\n    object-position: center 2.8%;\n  }\n\n  .vip-hero:not(.vip-hero--is-playing) .vip-hero-bg {\n    object-position: center 2.8%;\n  }\n\n  .ds-footer-content{\n    justify-content: center !important;\n  }\n\n  .vip-hero-content--desktop {\n    display: none !important;\n  }\n\n  .vip-hero-content--mobile {\n    display: block !important;\n    position: absolute !important;\n    bottom: 0px !important;\n    left: 0 !important;\n    right: 0 !important;\n    width: 100% !important;\n    max-width: none !important;\n    background: linear-gradient(\n      to top,\n      #000000 0%,\n      rgba(0, 0, 0, 0.95) 15%,\n      rgba(0, 0, 0, 0.75) 35%,\n      rgba(0, 0, 0, 0.45) 60%,\n      rgba(0, 0, 0, 0.15) 80%,\n      rgba(0, 0, 0, 0) 100%\n    );\n    z-index: 15 !important;\n    margin: 0 !important;\n    padding: 0 12px !important;\n    line-height: 20px !important;\n  }\n\n  .trending-scroll--vip-mobile-playing .vip-after-hero {\n    margin-top: 0;\n    padding: 0 0 12px;\n    background: rgba(0, 0, 0, 0.72);\n  }\n\n  .trending-scroll--vip-mobile-playing .vip-after-hero-top-gap {\n    display: block;\n    height: 4px;\n    position: sticky;\n    top: 0;\n    z-index: 2;\n    background: rgba(0, 0, 0, 1);\n  }\n\n  .app-main-with-footer.app-main-with-footer--footer-hidden .trending-scroll--vip-mobile-playing {\n    height: calc(100dvh - 56px);\n  }\n\n  .slider-container.slider-row.first-row {\n    padding-top: 0 !important;\n    margin-bottom: 0;\n  }\n\n  .vip-hero-title {\n    font-family: \"Space Grotesk\", sans-serif;\n    font-size: 16px !important;\n    line-height: 20px !important;\n    padding: 2px 6px !important;\n    margin-bottom: 2px;\n    border-radius: 8px;\n  }\n\n  .news-block__title {\n    font-size: 16.8px !important;\n  }\n  .vip-hero-play-btn {\n    padding: 8px 18px;\n  }\n\n  .vip-hero {\n    position: relative;\n    cursor: pointer;\n  }\n\n  .vip-hero-play-btn-overlay {\n    position: absolute;\n    inset: 0;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background: rgba(0, 0, 0, 0.15);\n    z-index: 10;\n    pointer-events: auto;\n  }\n\n  .vip-hero-play-icon {\n    width: 58px;\n    height: 58px;\n    border-radius: 50%;\n    background: rgba(0, 0, 0, 0.42);\n    border: 2px solid rgba(255, 255, 255, 0.72);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    color: #ffffff;\n    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.4);\n    transition: transform 0.2s ease, background-color 0.2s ease;\n    -webkit-tap-highlight-color: transparent;\n\n    .play-glyph {\n      width: 20px;\n      height: 40px;\n      margin-left: 5px;\n      transform: scale(0.86);\n    }\n    \n    &:active {\n      transform: scale(0.92);\n      background: rgba(111, 94, 168, 0.95);\n    }\n  }\n}\n\n.app-main-with-footer {\n  --footer-height: 31px;\n  --footer-top-fade: 48px;\n  --footer-safe-gap: 24px;\n  --vip-after-hero-overlap: 0px;\n  --vip-overlap-bottom-offset: 2px;\n  --vip-first-row-top-padding: 84px;\n  padding-bottom: var(--footer-safe-gap) !important;\n}\n\n/* ===== FOOTER ===== */\n@media (max-width: 768px) {\n  .ds-footer {\n    background: #000 !important;\n    height: 20px !important;\n}\n}\n.ds-footer {\n  position: relative;\n  bottom: auto;\n  left: auto;\n  width: 100%;\n  height: var(--footer-height, 40px);\n  background: linear-gradient(\n    to bottom,\n    rgba(8, 8, 12, 0.9),\n    rgba(8, 8, 12, 0.86)\n  );\n  // backdrop-filter: blur(6px);  \n  z-index: 999;\n  display: flex;\n  align-items: center;\n  isolation: isolate;\n  overflow: visible;\n  transition:\n    transform 0.28s ease,\n    opacity 0.28s ease,\n    visibility 0.28s ease;\n}\n\n.ds-footer--hidden {\n  transform: translateY(100%);\n  opacity: 0;\n  visibility: hidden;\n  pointer-events: none;\n}\n\n.ds-footer--hidden::before {\n  opacity: 0;\n}\n\nbody:has(.ds-footer--hidden) .app-main-with-footer {\n  padding-bottom: var(--footer-safe-gap, 24px) !important;\n}\n\n.app-main-with-footer.app-main-with-footer--footer-hidden {\n  padding-bottom: 0 !important;\n}\n\nbody:has(.ds-footer--hidden) .app-main-with-footer.app-main-with-footer--footer-hidden {\n  padding-bottom: 0 !important;\n}\n\n.ds-footer::after {\n  content: \"▾\";\n  position: absolute;\n  left: 8px;\n  top: 45%;\n  transform: translateY(-50%);\n  font-size: calc(var(--footer-height, 31px) * 1.45);\n  font-weight: 950;\n  line-height: var(--footer-height, 31px);\n  height: var(--footer-height, 31px);\n  width: calc(var(--footer-height, 31px) * 1);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #ffffff;\n  text-shadow:\n    0 0 8px rgba(255, 255, 255, 0.75),\n    0 0 18px rgba(125, 211, 252, 0.65),\n    0 0 28px rgba(59, 130, 246, 0.55);\n  pointer-events: none;\n  animation: ds-scroll-attention 0.85s ease-in-out infinite;\n  transition: opacity 0.22s ease, visibility 0.22s ease;\n}\n@media (max-width: 768px) {\n  .ds-footer::after {\n    left : -4px;\n  }\n}\n\n.ds-footer--scroll-end::after {\n  opacity: 0;\n  visibility: hidden;\n  animation: none;\n}\n\n.ds-footer::before {\n  content: \"\";\n  position: absolute;\n  left: 0;\n  right: 0;\n  bottom: 100%;\n  height: var(--footer-top-fade, 48px);\n  pointer-events: none;\n  background: linear-gradient(\n    to top,\n    rgba(75, 63, 94, 0) 0%,\n    rgba(32, 27, 42, 0.14) 45%,\n    rgba(32, 27, 42, 0) 100%\n  );\n}\n\n/* Footer: stronger bar on mobile (≤800px); lighter / less smoked on desktop (>800px) */\n@media (min-width: 801px) {\n  .ds-footer {\n    background: linear-gradient(\n      to bottom,\n      rgba(22, 20, 32, 0.62),\n      rgba(22, 20, 32, 0.5)\n    );\n  }\n\n  .ds-footer::before {\n    background: linear-gradient(\n      to top,\n      rgba(75, 63, 94, 0) 0%,\n      rgba(32, 27, 42, 0.06) 45%,\n      rgba(32, 27, 42, 0) 100%\n    );\n  }\n}\n\n@keyframes ds-scroll-attention {\n  0%,\n  100% {\n    opacity: 0.35;\n  }\n  50% {\n    opacity: 1;\n  }\n}\n\n/* content align right */\n.ds-footer-content {\n  position: relative;\n  z-index: 1;\n  width: 100%;\n  display: flex;\n  justify-content: flex-end;\n  padding: 0 40px;\n}\n\n.ds-footer-right {\n  display: flex;\n  gap: 20px;\n}\n\n@media (min-width: 801px) {\n  .ds-footer-right {\n    position: relative;\n    display: inline-flex;\n    align-items: center;\n    gap: 20px;\n    padding: 6px 14px;\n    isolation: isolate;\n  }\n\n  .ds-footer-right::before {\n    content: \"\";\n    position: absolute;\n    inset: 0;\n    border-radius: inherit;\n    background: rgba(12, 10, 18, 0.24);\n    -webkit-backdrop-filter: blur(10px);\n    backdrop-filter: blur(5px);\n    box-shadow:\n      0 0 0 1px rgba(255, 255, 255, 0.06),\n      0 8px 22px rgba(0, 0, 0, 0.2);\n    z-index: -1;\n    pointer-events: none;\n  }\n\n  .ds-footer-right a {\n    position: relative;\n    z-index: 1;\n  }\n}\n\n@media (max-width: 1400px) {\n  .ds-footer-content {\n    padding: 0 20px;\n  }\n}\n\n@media (max-width: 800px) {\n  .ds-footer-content {\n    padding: 0 10px;\n  }\n  }\n\n/* links style */\n.ds-footer-right a {\n  color: #fff;\n  font-size: 13px;\n  text-decoration: none;\n  transition: 0.2s;\n  font-weight: bolder;\n}\n@media (max-width: 800px) {\n  .ds-footer-right a {\n    font-size: 11px;\n  }\n}\n\n.ds-footer-right a:hover {\n  color: #7dd3fc;\n  text-decoration: underline;\n}\n\n/* CSS triangle — Safari draws a grey box around the ▶ character */\n.play-glyph {\n  display: block;\n  width: 22px;\n  height: 26px;\n  background: currentColor;\n  clip-path: polygon(0 22%, 100% 50%, 0 78%);\n  flex-shrink: 0;\n}\n\n.play-btn {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: white;\n  -webkit-tap-highlight-color: transparent;\n\n  .play-glyph {\n    width: 32px;\n    height: 38px;\n    filter: drop-shadow(0 2px 8px rgba(0, 0, 0, 0.45));\n  }\n}\n\n@media (max-width: 800px) {\n  .play-btn .play-glyph {\n    width: 14px;\n    height: 17px;\n  }\n}\n\n\n/* ── Engagement bar (likes / dislikes / comments) ─────────────────────────── */\n.engagement-bar {\n  display: inline-flex;\n  vertical-align: middle;\n  align-items: center;\n  gap: 6px;\n  padding: 5px 2px 2px;\n  margin-top: 4px;\n}\n\n.engagement-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  background: rgba(255, 255, 255, 0.04);\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  border-radius: 999px;\n  padding: 4px 10px 4px 8px;\n  cursor: pointer;\n  transition: background 0.15s, border-color 0.15s, transform 0.12s;\n  color: #64748b;\n  font-size: 0.8rem;\n  font-weight: 600;\n  line-height: 1;\n}\n\n.engagement-btn:hover {\n  background: rgba(99, 102, 241, 0.12);\n  border-color: rgba(99, 102, 241, 0.3);\n  color: #94a3b8;\n  transform: scale(1.05);\n}\n\n.engagement-btn--active-like {\n  background: rgba(34, 197, 94, 0.10);\n  border-color: rgba(34, 197, 94, 0.35);\n  color: #4ade80;\n}\n\n.engagement-btn--active-dislike {\n  background: rgba(239, 68, 68, 0.10);\n  border-color: rgba(239, 68, 68, 0.3);\n  color: #f87171;\n}\n\n.engagement-btn--comment {\n  margin-left: 4px;\n}\n\n.engagement-btn--comment:hover {\n  background: rgba(99, 102, 241, 0.14);\n  border-color: rgba(99, 102, 241, 0.35);\n  color: #a5b4fc;\n}\n\n.engagement-icon {\n  font-size: 0.85rem;\n  line-height: 1;\n}\n\n.engagement-count {\n  font-size: 0.78rem;\n  font-weight: 700;\n  min-width: 14px;\n}\n\n\n/* Engagement bar under headline tweak */\n.headline-and-engagement {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) auto;\n  align-items: start;\n  column-gap: 10px;\n  width: 100%;\n  box-sizing: border-box;\n  padding-left: var(--vip-row-gutter, 40px);\n  padding-right: 6px;\n  margin-bottom: 2px;\n}\n\n.headline-and-engagement .news-block__title {\n  width: auto !important;\n  min-width: 0;\n  grid-column: 1;\n  grid-row: 1;\n  margin: 0 !important;\n}\n\n.headline-and-engagement__comment {\n  grid-column: 2;\n  grid-row: 1;\n  justify-self: end;\n  align-self: start;\n  flex-shrink: 0;\n  margin-left: 0;\n  margin-top: 0;\n  top: 0;\n}\n\n@media (max-width: 800px) {\n  .headline-and-engagement {\n    display: block;\n    padding-left: 12px;\n    padding-right: 0;\n  }\n\n  .headline-and-engagement::after {\n    content: \"\";\n    display: block;\n    clear: both;\n  }\n\n  .headline-and-engagement .news-block__title {\n    display: block;\n    width: auto !important;\n  }\n\n  .headline-and-engagement__comment {\n    float: right;\n    margin-left: 8px;\n  }\n}\n\n.engagement-bar {\n  margin-top: 2px !important;\n  padding-left: 0 !important;\n}\n\n@keyframes brightBlink {\n  0% { opacity: 0.85; filter: drop-shadow(0 0 2px rgba(255,255,255,0.5)); transform: scale(1); }\n  50% { opacity: 1; filter: drop-shadow(0 0 10px #fff) drop-shadow(0 0 18px #c084fc); transform: scale(1.22); color: #fff; }\n  100% { opacity: 0.85; filter: drop-shadow(0 0 2px rgba(255,255,255,0.5)); transform: scale(1); }\n}\n\n.blinking-comment-icon {\n  animation: brightBlink 1.4s infinite ease-in-out;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  color: #e6d7ff;\n  vertical-align: baseline;\n  margin-left: 6px;\n  padding: 0;\n  border: 0;\n  background: transparent;\n  font: inherit;\n  cursor: pointer;\n  transform-origin: center;\n  position: relative;\n  top: 2px;\n}\n@media (max-width: 800px) {\n  .blinking-comment-icon {\n    margin-left: 0px;\n  }\n  .blinking-comment-icon::before {\n    content: \"\";\n    position: absolute;\n    inset: -16px;\n    min-width: 44px;\n    min-height: 44px;\n  }\n}\n\n.blinking-comment-icon .comment-bubble-svg {\n  width: 12px;\n  height: 12px;\n  fill: none;\n  stroke: currentColor;\n  stroke-width: 1.8;\n  stroke-linejoin: round;\n}\n\n.blinking-comment-icon .count {\n  font-size: 13px;\n  font-weight: 800;\n  margin-left: 3px;\n}\n\n.blinking-comment-icon:focus-visible {\n  outline: 2px solid rgba(196, 181, 253, 0.9);\n  outline-offset: 3px;\n  border-radius: 4px;\n}\n\n@media (min-width: 801px) {\n  .blinking-comment-icon .comment-bubble-svg {\n    width: 24px;\n    height: 24px;\n  }\n\n  .blinking-comment-icon .count {\n    font-size: 15px;\n  }\n}\n\n\n.modal-chunk-loading-backdrop {\n  position: fixed;\n  inset: 0;\n  z-index: 9999;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 20px;\n  background: rgba(10, 8, 19, 0.72);\n  backdrop-filter: blur(6px);\n}\n\n.modal-chunk-loading-card {\n  padding: 14px 18px;\n  border: 1px solid rgba(167, 139, 250, 0.28);\n  border-radius: 10px;\n  background: #171120;\n  color: #ddd6fe;\n  font: 600 14px/1.3 \"Space Grotesk\", sans-serif;\n}\n\n/* Last-resort guard so malformed AI output cannot crash the entire React tree. */\n.analysis-render-error-backdrop {\n  position: fixed;\n  inset: 0;\n  z-index: 10000;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 20px;\n  background: rgba(10, 8, 19, 0.82);\n  backdrop-filter: blur(8px);\n}\n.analysis-render-error-card {\n  width: min(92vw, 520px);\n  padding: 24px;\n  border: 1px solid rgba(167, 139, 250, 0.28);\n  border-radius: 16px;\n  background: #171120;\n  color: #f5f3ff;\n  font-family: \"Space Grotesk\", sans-serif;\n  box-shadow: 0 24px 80px rgba(0, 0, 0, 0.55);\n}\n.analysis-render-error-card h2 {\n  margin: 0 0 10px;\n  color: #c4b5fd;\n  font-family: \"Orbitron\", \"Space Grotesk\", sans-serif;\n  font-size: 18px;\n}\n.analysis-render-error-card p {\n  margin: 0 0 18px;\n  color: rgba(245, 243, 255, 0.8);\n  line-height: 1.5;\n}\n.analysis-render-error-card button {\n  border: 1px solid rgba(196, 181, 253, 0.45);\n  border-radius: 8px;\n  padding: 8px 16px;\n  background: rgba(124, 58, 237, 0.2);\n  color: #fff;\n  cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
